import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import InputField from '../../../components/formElements/InputField';
import { Settings } from '@mui/icons-material';
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Backdrop,
  CircularProgress,
  MenuItem,
  ListItemText,
  FormControl,
  Grid,
  Autocomplete,
  Chip,
  Tooltip,
  ListItem,
  List,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { API, graphqlOperation } from 'aws-amplify';
import ConfirmCancel from '../../../components/modals/confirmCancel';
import './CompanySetup.css';
import CheckBoxWithLabel from '../../../components/formElements/CheckBoxWithLabel';
import { useLazyFetchPincodeLocationQuery } from '../../../features/CompanycodeTranslation/Api/pincodeLocation.api';
import { useDispatch, useSelector } from 'react-redux';
import { gst } from '../../../redux/reducers/gstStatus';
import { createCompanyDocuments, createNumberTracker } from '../../../graphql';
import { fetchCompany, setCompanyName } from '../../../redux/reducers/CompanySlice';
import { uploadToServer } from '../../../library/upload';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import MUIDatePicker from '../../../components/formElements/DatePicker';
import AllSettings from '../../NewFigma/AllSettings/AllSettings';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import AutoCompleteMUI from '../../../components/formElements/AutoCompleteMUI';
import { compositionScheme, entityOptions, humanizeKey } from '../../../utils/customerData';
import AddTypeModal from './Components/Modals/AddTypeModal';
import Attachment from '../../NewFigma/AddCustomer/attachment';
import LutViewNewModal from '../../../components/modals/LutViewNewModal';
import DraggableAction from '../../../components/Buttons/DraggableAction';
import { axiosInstanceForLambda } from '../../../library/Axios';
import useSaveShortcut from '../../../hooks/useSaveShortcut';
import { createPartyAddressEntity, createcompanydetails, createcompanyentity, getCompanyV2 } from '../../../graphql';
import { initialCompanyData } from './data';
import API_ENDPOINTS from '../../../apiEndpoints';
import moment from 'moment';
import { FetchGstInDetails } from '../../../library/GstinFetch';
import InfoButton from '../../../components/Buttons/InfoButton';
import { setNavigationBlocked } from '../../../redux/reducers/controllNavigation';
import useControlledNavigation from '../../../hooks/useControlledNavigation';
import SimpleModal from '../../../components/modals/simpleModal';
import { ewayBillNotes } from './ewayBillNotes';
import { einvNotes } from './einvNotes';
import Country from '../../../features/CompanycodeTranslation/components/country';
import State from '../../../features/CompanycodeTranslation/components/state';
import District from '../../../features/CompanycodeTranslation/components/district';
import City from '../../../features/CompanycodeTranslation/components/city';
import Pincode from '../../../features/CompanycodeTranslation/components/pincode';
import CompanysetupEway from './companysetupEway';
import { useLazyGetDistrictOptionsQuery } from '../../../features/CompanycodeTranslation/Api/countryApi';
import { useLazyGetBusinessOptionsQuery, useLazyGetIndustryOptionsQuery } from '../../../features/CompanySetup/Api/BuzIndType.api';

const initialLogo = {
  LogoName: '0',
  LOGOURL: '',
  Type: '',
};

function NewCompanySetup() {
  const imageRef = useRef();
  const panref = useRef();
  const entityRef = useRef();
  const logoRef = useRef();
  const settingsRef = useRef(null);
  const linkRef = useRef(null);
  const legalref = useRef();
  const shortref = useRef();
  const mailref = useRef();
  const mobileref = useRef();
  const webref = useRef();
  const gstinref = useRef();
  const usernameRef = useRef();
  const lutFrom = useRef();
  const lutTo = useRef();
  const tradeFrom = useRef();
  const tradeTo = useRef();
  const tanref = useRef();
  const countryref = useRef();
  const stateref = useRef();
  const districtref = useRef();
  const pincoderef = useRef();
  const compref = useRef();
  const cityref = useRef(null);
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useControlledNavigation();
  const location = useLocation();
  const [updatePassword, setUpdatePassword] = useState(false);
  const [hideFloatBtn, setHideFloatBtn] = useState(false);
  const [ewayUpdatePassword, setEwayUpdatePassword] = useState(false);
  const [ewayNotes, setEwayNotes] = useState(false);
  const [eInvNotes, setEInvNotes] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editableValue, setEditableValue] = useState('');
  const [companyData, setCompanyData] = useState({});
  const [backdropOpen, setBackdropOpen] = useState(false);
  // const [initialLoadingComplete, setInitialLoadingComplete] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(initialLogo);
  const [businessorIndustryType, setBusinessorIndustryType] = useState('');
  const [openBusinessIndustryTypeModal, setOpenBusinessIndustryTypeMdal] = useState();
  const [businessTypes, setBusinessTypes] = useState([]);
  const [industryTypes, setIndustryTypes] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [changedValues, setChangedValues] = useState([]);
  const [options, setOptions] = useState([]);
  const [regularSetting, setRegularSettings] = useState(null);
  const { activeValue } = location.state || {};
  const [businessTypeFn, { data: BizData }] = useLazyGetBusinessOptionsQuery();
  const [IndustryTypeFn, { data: IndData }] = useLazyGetIndustryOptionsQuery();

  useEffect(() => {
    if (activeValue !== undefined) {
      setActiveStep(activeValue);
    }
  }, [activeValue]);

  const [partyBool, setPartyBool] = useState(true);
  const [previousState, setPreviousState] = useState('');
  const [districtList, setDistrictList] = useState([]);

  // RTK Query hook for pincode location fetching with caching

  const companyDetails = useSelector((state) => state?.companyReducer?.companyDetails);
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  console.log(companyDetails, 'companyDetails');

  const [state, setState] = useState(initialCompanyData);
  const [initialStateSnapshot, setInitialStateSnapshot] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [snapshotTaken, setSnapshotTaken] = useState(false);
  const [editMode, setEditMode] = useState(false);
  // const [invoiceFetching,setInvoiceFetching]=useState

  const checkForUnsavedChanges = useCallback(() => {
    if (!initialStateSnapshot || !snapshotTaken) return null;

    const excludeFields = ['lutExpiry', 'expiresin', 'errorStatus', 'errorFields'];

    const getCleanFormData = (formData) => {
      const { errorStatus, errorFields, ...formOneData } = formData.formone;
      const { errorStatus: errorStatus2, errorFields: errorFields2, lutExpiry, expiresin, ...formTwoData } = formData.formtwo;
      return { formone: formOneData, formtwo: formTwoData };
    };

    const currentData = getCleanFormData(state);
    const initialData = getCleanFormData(initialStateSnapshot);

    const hasFormChanges = JSON.stringify(currentData) !== JSON.stringify(initialData);
    const hasAttachmentChanges = attachments.length !== documents.length;

    return hasFormChanges || hasAttachmentChanges;
  }, [state, initialStateSnapshot, attachments, documents, snapshotTaken]);
  const [pincodeData] = useLazyFetchPincodeLocationQuery();
  const [getDistrictOptions] = useLazyGetDistrictOptionsQuery();
  useEffect(() => {
    if (editMode && companyDetails && !snapshotTaken) {
      const timer = setTimeout(() => {
        if (editMode) {
          setInitialStateSnapshot(JSON.parse(JSON.stringify(state)));
          setSnapshotTaken(true);
        }
      }, 0);
      return () => clearTimeout(timer);
    }

    if (!editMode) {
      setInitialStateSnapshot(null);
      setSnapshotTaken(false);
    }
  }, [editMode, companyDetails, snapshotTaken, dispatch]);

  const { isBlocked } = useSelector((state) => state.controllNavigationSlice);

  useEffect(() => {
    const hasChanges = checkForUnsavedChanges();
    if (isBlocked) return;
    setHasUnsavedChanges(hasChanges);
    if (hasChanges) {
      dispatch(setNavigationBlocked(true));
      return;
    } else {
      dispatch(setNavigationBlocked(false));
    }
    return () => {
      dispatch(setNavigationBlocked(false));
    };
  }, [state, attachments, documents]);

  useEffect(() => {
    if (editMode && !initialStateSnapshot && companyDetails && state.formone.legalName) {
      const timer = setTimeout(() => {
        setInitialStateSnapshot(JSON.parse(JSON.stringify(state)));
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [editMode, initialStateSnapshot, companyDetails]);

  const newEntityOptions = entityOptions.map((item) => ({
    option: item.label,
    value: item.id,
    panIdentifier: item.panIdentifier,
  }));
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Tab' && nextFieldRef.current) {
      e.preventDefault(); // Prevent default tab behavior
      nextFieldRef.current.focus(); // Move focus to the next field
    }
  };
  console.log(businessTypes, 'businessTypes');

  const stepItemStyle = (active) => {
    return {
      display: 'flex',
      textAlign: 'center',
      flexWrap: 'wrap',
      padding: '10px',
      borderRadius: '5px',
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px',
      cursor: 'pointer',
      position: 'relative',
      justifyContent: 'center',
      backgroundColor: activeStep === active ? 'primary.main' : theme?.palette?.TmId.id.toString().includes('9') ? '#3A3A42' : 'white',
      color: activeStep === active ? 'white' : 'input.font',
    };
  };

  const stepRightTriangle = (active) => {
    return {
      position: 'absolute',
      display: { xs: 'none', sm: 'block', md: 'block', lg: 'block' },
      width: '30px',
      height: '30px',
      top: '5px',
      right: '-12px',
      borderRadius: '5px 0',
      background:
        activeStep === active ? theme.palette?.primary.main : theme?.palette?.TmId.id.toString().includes('9') ? '#3A3A42' : '#fff',
      borderTop: '4px solid',
      borderTopColor: 'bodyGray.main',
      borderRight: '4px solid',
      borderRightColor: 'bodyGray.main',
      transform: 'rotate(45deg)',
      zIndex: 9,
    };
  };

  function getFinancialYearEndDate(inputDate) {
    const date = new Date(inputDate);

    if (date.getMonth() <= 2 && date.getDate() <= 31) {
      return new Date(date.getFullYear(), 2, 31);
    } else {
      return new Date(date.getFullYear() + 1, 2, 31);
    }
  }
  function timestampToDate(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  const [stateList, setStateList] = useState([]);
  console.log(stateList, 'stateList');

  const handleStateChange = useCallback((option, val) => {
    if (val?.value) {
      setPreviousState(val?.value);

      // updateState('formone', 'states', val?.value, false, '');
      updateState('formone', 'states', val?.value, false, '');
      updateState('formone', 'district', '', true, 'District is Required');
      updateState('formone', 'city', '', true, 'City is Required');
    } else {
      updateState('formone', 'states', '', true, 'State is Required');
      updateState('formone', 'district', '', true, 'District is Required');
      updateState('formone', 'city', '', true, 'City is Required');
    }
  }, []);

  const handleDistrictChange = useCallback((option, val) => {
    if (val?.value) {
      updateState('formone', 'district', val?.value, false, '');
    } else {
      updateState('formone', 'district', '', true, 'District is Required');
    }
  }, []);

  const handleCityChange = useCallback((e, value) => {
    if (value) {
      setState((prev) => ({
        ...prev,
        ['formone']: {
          ...prev['formone'],
          city: value,
          errorStatus: {
            ...prev['formone'].errorStatus,
            city: false,
          },
          errorFields: {
            ...prev['formone'].errorFields,
            city: '',
          },
        },
      }));
    } else {
      updateState('formone', 'city', '', true, 'City is required');
    }
  }, []);

  const handleDateChange = (date, context, form, name, companyValue) => {
    const dateValue = companyValue !== 0 ? timestampToDate(companyValue * 1000) : '';
    let arr = changedValues?.filter((item) => item?.name !== name);
    let obj = { form: form, name: name, savedValue: dateValue };
    arr.push(obj);
    setChangedValues(arr);
    if (date === null) {
      setState((prev) => ({
        ...prev,
        [form]: {
          ...prev[form],
          [name]: '',
          errorStatus: { ...prev[form].errorStatus, [name]: false },
          errorFields: { ...prev[form].errorFields, [name]: '' },
        },
      }));
    } else if (context.validationError !== null) {
    } else {
      let newDate = date?.$d;
      let value = newDate
        ? `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`
        : null;
      switch (name) {
        case 'ewayBillStartDate':
        case 'eInvoiceStartDate':
        case 'cinRegDate':
          setState((prev) => ({
            ...prev,
            [form]: {
              ...prev[form],
              [name]: dayjs(date),
              errorStatus: { ...prev[form].errorStatus, [name]: false },
              errorFields: { ...prev[form].errorFields, [name]: '' },
            },
          }));
          break;
        case 'tradeLicNoFromDate':
          if (value !== '') {
            const currentDate = moment().format('YYYY-MM-DD');
            const finEndDate = moment(getFinancialYearEndDate(value)).format('YYYY-MM-DD');

            const daysDifference = moment(finEndDate).diff(moment(currentDate), 'days');
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: dayjs(date),
                ['tradeLicNoToDate']: value ? dayjs(finEndDate) : '',
                ['expiresin']: daysDifference < 0 ? 'expired' : daysDifference,
                errorStatus: {
                  ...prev[form].errorStatus,
                  [name]: false,
                  ['tradeLicNoToDate']: false,
                  ['expiresin']: false,
                },
                errorFields: {
                  ...prev[form].errorFields,
                  [name]: '',
                  ['tradeLicNoToDate']: '',
                  ['expiresin']: '',
                },
              },
            }));
          } else {
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: dayjs(date),
                errorStatus: { ...prev[form].errorStatus, [name]: false },
                errorFields: { ...prev[form].errorFields, [name]: '' },
              },
            }));
          }
          break;
        case 'tradeLicNoToDate':
          if (value !== '') {
            let newDate = state?.formtwo?.tradeLicNoFromDate?.$d;
            let validFrom = newDate
              ? `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`
              : null;
            const currentDate = moment().format('YYYY-MM-DD');
            const finEndDate = moment(value).format('YYYY-MM-DD');
            const daysDifference = moment(finEndDate).diff(moment(currentDate), 'days');
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: dayjs(date),
                ['expiresin']: daysDifference < 0 ? 'expired' : daysDifference,
                errorStatus: {
                  ...prev[form].errorStatus,
                  [name]: false,
                  ['expiresin']: false,
                },
                errorFields: {
                  ...prev[form].errorFields,
                  [name]: '',
                  ['expiresin']: '',
                },
              },
            }));
          } else {
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: dayjs(date),
                errorStatus: { ...prev[form].errorStatus, [name]: false },
                errorFields: { ...prev[form].errorFields, [name]: '' },
              },
            }));
          }
          break;
        case 'lutValidFrom':
          if (value !== '') {
            const currentDate = moment().format('YYYY-MM-DD');
            const finEndDate = moment(getFinancialYearEndDate(value)).format('YYYY-MM-DD');

            const daysDifference = moment(finEndDate).diff(moment(currentDate), 'days');
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: dayjs(date),
                ['lutValidTo']: value ? dayjs(finEndDate) : '',
                ['lutExpiry']: daysDifference < 0 ? 'expired' : daysDifference,
                errorStatus: {
                  ...prev[form].errorStatus,
                  ['lutExpiry']: false,
                  ['lutValidTo']: false,
                  [name]: false,
                },
                errorFields: {
                  ...prev[form].errorFields,
                  ['lutExpiry']: '',
                  ['lutValidTo']: '',
                  [name]: '',
                },
              },
            }));
          }
          break;
        case 'lutValidTo':
          if (value !== '') {
            const currentDate = moment().format('YYYY-MM-DD');
            const finEndDate = moment(value).format('YYYY-MM-DD');
            const daysDifference = moment(finEndDate).diff(moment(currentDate), 'days');
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: dayjs(date),
                ['lutExpiry']: daysDifference < 0 ? 'expired' : daysDifference,
                errorStatus: {
                  ...prev[form].errorStatus,
                  ['lutExpiry']: false,
                  [name]: false,
                },
                errorFields: {
                  ...prev[form].errorFields,
                  ['lutExpiry']: '',
                  [name]: '',
                },
              },
            }));
          }
          break;
        default:
          break;
      }
    }
  };

  const handleMobileChange = (value) => {
    if (value.split(' ').length <= 1) {
      setState((prev) => ({
        ...prev,
        ['formone']: {
          ...prev['formone'],
          ['mobile']: value,
          ['errorStatus']: {
            ...prev['formone'].errorStatus,
            ['mobile']: true,
          },
          ['errorFields']: {
            ...prev['formone'].errorFields,
            ['mobile']: 'Mobile Number is required',
          },
        },
      }));
    } else {
      if (!matchIsValidTel(value)) {
        setState((prev) => ({
          ...prev,
          ['formone']: {
            ...prev['formone'],
            ['mobile']: value,
            ['errorStatus']: {
              ...prev['formone'].errorStatus,
              ['mobile']: true,
            },
            ['errorFields']: {
              ...prev['formone'].errorFields,
              ['mobile']: 'Mobile Number is Invalid',
            },
          },
        }));
      } else {
        setState((prev) => ({
          ...prev,
          ['formone']: {
            ...prev['formone'],
            ['mobile']: value,
            ['errorStatus']: {
              ...prev['formone'].errorStatus,
              ['mobile']: false,
            },
            ['errorFields']: {
              ...prev['formone'].errorFields,
              ['mobile']: '',
            },
          },
        }));
      }
    }
  };
  const onEinvConnectChange = (event) => {
    const check = async () => {
      if (state.formtwo.connect === 0) {
        try {
          setBackdropOpen(true);
          // const eInvoiceValidate = async () => {
          if (state.formtwo.username && state.formtwo.password) {
            const ewayEinUrl = API_ENDPOINTS.REACT_APP_EINVOICE_URL;
            const payload = {
              action: 'validateCredentials',
              data: {
                userName: state.formtwo.username,
                password: state.formtwo.password,
                gstin: state.formtwo.gstin,
              },
            };
            try {
              const res = await axiosInstanceForLambda.post(ewayEinUrl, payload);
              setState((prev) => ({
                ...prev,
                ['formtwo']: {
                  ...prev['formtwo'],
                  ['connect']: 1,
                },
              }));
              showSuccessSnackbar('Credentials validated successfully');
            } catch {
              showWarningSnackbar('Invalid Credentials\n[Refer to "Steps to Configure & Generate E-Invoice" for details]');
            }
          } else {
            showWarningSnackbar('Please provide User name and password');
            return;
          }
        } catch {
          showWarningSnackbar('Invalid Credentials');
        } finally {
          setBackdropOpen(false);
        }
        // };
      } else {
        setState((prev) => ({
          ...prev,
          ['formtwo']: {
            ...prev['formtwo'],
            ['connect']: 0,
            ['username']: '',
            ['password']: '',
          },
        }));
      }
    };
    if (companyDetails?.einvoiceusername === null) {
      if (state.formtwo.username && state.formtwo.password) {
        check();
      } else {
        showWarningSnackbar('Please provide username and password');
      }
    } else {
      if (state.formtwo.username) {
        check();
      }
    }
  };
  const onEwayConnectChange = (event) => {
    const check = async () => {
      if (state.formtwo.ewayconnect === 0) {
        try {
          if (state.formtwo.ewayusername && state.formtwo.ewaypassword) {
            const ewayEinUrl = API_ENDPOINTS.REACT_APP_EWAYBILL_URL;
            const payload = {
              action: 'validateCredentials',
              credentials: {
                userName: state.formtwo.ewayusername,
                password: state.formtwo.ewaypassword,
                gstin: state.formtwo.gstin,
              },
            };
            try {
              const res = await axiosInstanceForLambda.post(ewayEinUrl, payload);
              setState((prev) => ({
                ...prev,
                ['formtwo']: {
                  ...prev['formtwo'],
                  ['ewayconnect']: 1,
                },
              }));
              showSuccessSnackbar('Credentials validated successfully');
            } catch {
              showWarningSnackbar('Invalid Credentials\n[Refer to "Steps to Configure & Generate E-Way Bill" for details]');
            }
          } else {
            showWarningSnackbar('Please provide User name and password');
            return;
          }
        } catch {
          showWarningSnackbar('Invalid Credentials');
        } finally {
          setBackdropOpen(false);
        }
      } else {
        setState((prev) => ({
          ...prev,
          ['formtwo']: {
            ...prev['formtwo'],
            ['ewayconnect']: 0,
            ['ewayusername']: '',
            ['ewaypassword']: '',
          },
        }));
      }
    };
    if (companyDetails?.ewaybillusername === null) {
      if (state.formtwo.ewayusername && state.formtwo.ewaypassword) {
        check();
      } else {
        showWarningSnackbar('Please provide username and password');
      }
    } else {
      if (state.formtwo.ewayusername) {
        check();
      }
    }
  };

  const onEinvChange = (event) => {
    if (event?.target.checked) {
      setSettingsBool(false);
      showWarningSnackbar('Please ensure all fields filled in party address during party creation to create E-invoice');
      setState((prev) => ({
        ...prev,
        ['formtwo']: {
          ...prev['formtwo'],
          ['eInvoicing']: 1,
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        ['formtwo']: {
          ...prev['formtwo'],
          ['eInvoicing']: 0,
        },
      }));
    }
  };

  const onEwayChange = (event) => {
    if (event?.target.checked) {
      setSettingsBool(false);
      showWarningSnackbar('Please ensure all fields filled in party address during party creation to create E-way bill');
      setState((prev) => ({
        ...prev,
        ['formtwo']: {
          ...prev['formtwo'],
          ['eWayBill']: '1',
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        ['formtwo']: {
          ...prev['formtwo'],
          ['eWayBill']: '0',
        },
      }));
    }
  };

  useEffect(() => {
    if (editMode === true && state.formtwo.gstin.trim().length === 15 && state.formtwo.errorStatus.gstin === false) {
      const value = state.formtwo.gstin;
      async function gstinFetch() {
        try {
          let fetchData = await FetchGstInDetails(value);

          if (fetchData) {
            if (state.formtwo.errorStatus.gstin === false) {
              updateState('formtwo', 'pan', value?.substring(2, 12), false, '');
            }
          }
        } catch {
          showWarningSnackbar('GSTIN is NOT valid. Please recheck');
        }
      }
      gstinFetch();
    }
  }, [state.formtwo.gstin]);
  const handleChange = async (event, form, valid, companyValue) => {
    let { name, id, value } = event.target;
    let arr = changedValues;
    let obj = {
      form: form,
      name: name,
      savedValue: companyValue !== undefined || companyValue !== '' ? companyValue : '',
    };
    arr.push(obj);
    setChangedValues(arr);
    const toUpperCase = (str) => str.toUpperCase();

    // Function to capitalize first letter of each word
    const capitalizeWords = (str) => {
      if (!str) return str;
      return str.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const updateState = async (name, value, errorStatus, errorFields) => {
      if (
        name !== 'gstin' &&
        name !== 'website' &&
        name !== 'lutBondNo' &&
        name !== 'tradeLicenseNo' &&
        name !== 'cinRegNo' &&
        name !== 'TDSTCSNumber' &&
        name !== 'username' &&
        name !== 'ewayusername' &&
        name !== 'ewaypassword' &&
        name !== 'password' &&
        name !== 'city' &&
        name !== 'pan' &&
        name !== 'udhyamRegNo' &&
        name !== 'buisnessAddress' &&
        name !== 'district'
      ) {
        setState((prev) => ({
          ...prev,
          [form]: {
            ...prev[form],
            // [name]: value.trimStart(),
            [name]: value.trimStart(),
            errorStatus: { ...prev[form].errorStatus, [name]: errorStatus },
            errorFields: { ...prev[form].errorFields, [name]: errorFields },
          },
        }));
      } else if (name === 'district') {
        setState((prev) => ({
          ...prev,
          [form]: {
            ...prev[form],
            // [name]: value.trimStart(),
            [name]: value,
            errorStatus: { ...prev[form].errorStatus, [name]: errorStatus },
            errorFields: { ...prev[form].errorFields, [name]: errorFields },
          },
        }));
      } else if (name === 'buisnessAddress') {
        setState((prev) => ({
          ...prev,
          [form]: {
            ...prev[form],
            // [name]: value.trimStart(),
            [name]: value.trimStart(),
            errorStatus: { ...prev[form].errorStatus, [name]: errorStatus },
            errorFields: { ...prev[form].errorFields, [name]: errorFields },
          },
        }));
      } else if (
        name === 'website' ||
        name === 'lutBondNo' ||
        name === 'tradeLicenseNo' ||
        name === 'cinRegNo' ||
        name === 'TDSTCSNumber' ||
        name === 'username' ||
        name === 'password' ||
        name === 'ewayusername' ||
        name === 'ewaypassword' ||
        // name === 'city' ||
        name === 'entityType' ||
        name === 'pan' ||
        name === 'udhyamRegNo'
      ) {
        if (value.trim().length === 0) {
          if (name === 'pan' && state.formtwo.registrationType != 1 && (value.trim() === '' || value.trim().length === 0)) {
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: value.replace(/\s+/g, ' ').trimStart(),
                errorStatus: { ...prev[form].errorStatus, [name]: errorStatus },
                errorFields: { ...prev[form].errorFields, [name]: errorFields },
              },
            }));
          } else if (name === 'username') {
            if (name === 'username' && state.formtwo.password !== '') {
              setState((prev) => ({
                ...prev,
                [form]: {
                  ...prev[form],
                  [name]: value.replace(/\s+/g, ' ').trimStart(),
                  errorStatus: { ...prev[form].errorStatus, ['username']: true },
                  errorFields: {
                    ...prev[form].errorFields,
                    ['username']: 'User name cannot be empty with password filled',
                  },
                },
              }));
            } else if (value === '') {
              setState((prev) => ({
                ...prev,
                ['formtwo']: {
                  ...prev['formtwo'],
                  [name]: value.replace(/\s+/g, ' ').trimStart(),
                  ['connect']: 0,
                },
              }));
            }
          } else if (name === 'ewayusername') {
            if (name === 'ewayusername' && state.formtwo.ewaypassword !== '') {
              setState((prev) => ({
                ...prev,
                [form]: {
                  ...prev[form],
                  [name]: value.replace(/\s+/g, ' ').trimStart(),
                  errorStatus: { ...prev[form].errorStatus, ['ewayusername']: true },
                  errorFields: {
                    ...prev[form].errorFields,
                    ['ewayusername']: 'User name cannot be empty with password filled',
                  },
                },
              }));
            } else {
              if (value === '') {
                setState((prev) => ({
                  ...prev,
                  ['formtwo']: {
                    ...prev['formtwo'],
                    ['ewayconnect']: 0,
                    [name]: value.replace(/\s+/g, ' ').trimStart(),
                  },
                }));
              }
            }
          } else {
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: value.replace(/\s+/g, ' ').trimStart(),
                errorStatus: { ...prev[form].errorStatus, [name]: false },
                errorFields: { ...prev[form].errorFields, [name]: '' },
              },
            }));
          }
          if (name === 'lutBondNo') {
            updateState('lutValidFrom', '', false, '');
            updateState('lutValidTo', '', false, '');
            updateState('lutExpiry', '', false, '');
          }
          if (name === 'tradeLicenseNo') {
            updateState('tradeLicNoFromDate', '', false, '');
            updateState('tradeLicNoToDate', '', false, '');
            updateState('expiresin', '', false, '');
          }
        } else {
          setState((prev) => ({
            ...prev,
            [form]: {
              ...prev[form],
              [name]: value.replace(/\s+/g, ' ').trimStart(),
              errorStatus: { ...prev[form].errorStatus, [name]: errorStatus },
              errorFields: { ...prev[form].errorFields, [name]: errorFields },
            },
          }));
        }
      } else {
        if (value.length <= 15) {
          if (value.length === 15 && name === 'gstin') {
            if (valid.test(value)) {
              setState((prev) => ({
                ...prev,
                [form]: {
                  ...prev[form],
                  [name]: value.trim(),
                  errorStatus: { ...prev[form].errorStatus, [name]: false },
                  errorFields: { ...prev[form].errorFields, [name]: '' },
                },
              }));
            } else {
              setState((prev) => ({
                ...prev,
                [form]: {
                  ...prev[form],
                  [name]: value.replace(/\s+/g, ' ').trimStart(),
                  errorStatus: { ...prev[form].errorStatus, [name]: true },
                  errorFields: { ...prev[form].errorFields, [name]: 'Invalid GSTIN' },
                },
              }));
            }
          } else {
            setState((prev) => ({
              ...prev,
              [form]: {
                ...prev[form],
                [name]: value.replace(/\s+/g, ' ').trimStart(),
                errorStatus: { ...prev[form].errorStatus, [name]: errorStatus },
                errorFields: { ...prev[form].errorFields, [name]: errorFields },
              },
            }));
          }
        } else {
          setState((prev) => ({
            ...prev,
            [form]: {
              ...prev[form],
              [name]: value.trim(),
            },
          }));
        }
      }
    };

    function validateAmount(value) {
      value = value.replace(/,/g, '');
      if (value === '') {
        return '0';
      }
      if (!/^\d+(?:\.\d*)?$/.test(value)) {
        return null;
      }
      return value;
    }
    switch (name) {
      case 'TDSTCSNumber':
        if (value !== '') value = toUpperCase(value);
        break;
      case 'mobile':
        if (value !== '' && !matchIsValidTel(value)) {
          updateState('mobile', value, true, 'Mobile Number is Invalid');
        }
        break;
      case 'gstin':
        if (value !== '' && new RegExp(valid).test(value)) {
          updateState('pan', value?.substring(2, 12), false, '');
          updateState('gstin', value, false, '');
        }
        if (value !== '') value = toUpperCase(value);
        break;

      // case "gstApplicableDate":
      case 'ewayBillStartDate':
      case 'eInvoiceStartDate':
      case 'lutValidFrom':
      case 'lutValidTo':
      case 'cinRegDate':
      case 'tradeLicNoFromDate':
      case 'tradeLicNoToDate':
        let resValue = value.indexOf('-');
        if (resValue > 4) {
          return resValue;
        }
        break;
      case 'eWayBillInterStateAmount':
      case 'eWayBillIntraStateAmount':
        value = validateAmount(value);
        if (value === null) {
          return;
        }
        break;
      case 'pan':
        if (value !== '') value = toUpperCase(value);
        break;
      case 'legalName':
        if (value !== '') value = capitalizeWords(value);
        break;
      case 'shortName':
        if (value !== '') value = capitalizeWords(value);
        break;
      case 'country':
        if (state?.formone?.states !== '') updateState('states', '', '');
        if (state?.formone?.district !== '') updateState('district', '', '');
        break;

      default:
        break;
    }
    // const isRequiredField = requiredFields[form].includes(name);
    const isValid = value === '' || new RegExp(valid).test(value);

    if (value === '') {
      updateState(name, value, true, `${id} is required`);
    } else if (value !== '' && !isValid) {
      updateState(name, value, true, `Invalid ${id}`);
    } else {
      updateState(name, value, false, '');
    }
  };
  const updateState = (form, name, value, errorStatus, errorFields) => {
    setState((prev) => ({
      ...prev,
      [form]: {
        ...prev[form],
        [name]: value,
        errorStatus: { ...prev[form].errorStatus, [name]: errorStatus },
        errorFields: { ...prev[form].errorFields, [name]: errorFields },
      },
    }));
  };

  const handlePincodeChange = useCallback(async (e, pin) => {
    const value = e?.target?.value;
    // Only allow numeric input and limit to 6 digits
    const numericValue = value ? value.replace(/\D/g, '').slice(0, 6) : pin;

    // Clear fields immediately for better UX
    setState((prev) => ({
      ...prev,
      formone: {
        ...prev.formone,
        city: '',
        states: '',
        district: '',
        pincode: numericValue,
        errorStatus: {
          ...prev.formone.errorStatus,
          pincode: false,
        },
        errorFields: {
          ...prev.formone.errorFields,
          pincode: '',
        },
      },
    }));
    setOptions([]);

    // Handle validation immediately
    if (numericValue === '') {
      // Handle empty pincode
      setState((prev) => ({
        ...prev,
        formone: {
          ...prev.formone,
          pincode: '',
          errorStatus: { ...prev.formone.errorStatus, pincode: true },
          errorFields: { ...prev.formone.errorFields, pincode: 'Pincode is required' },
        },
      }));
    } else if (numericValue.length < 6) {
      // Handle incomplete pincode (less than 6 digits)
      setState((prev) => ({
        ...prev,
        formone: {
          ...prev.formone,
          pincode: numericValue,
          errorStatus: {
            ...prev.formone.errorStatus,
            pincode: true,
          },
          errorFields: {
            ...prev.formone.errorFields,
            pincode: 'Pincode must be 6 digits',
          },
        },
      }));
    } else if (numericValue.length === 6) {
      // Use debounced API call for 6-digit pincode
      // if (pincodeData && currentPincode) {
      try {
        const { data } = await pincodeData({ pincode: numericValue }, true);
        // Single state update with all data
        const newState = data.State + 'District';
        setState((prev) => ({
          ...prev,
          formone: {
            ...prev.formone,
            states: data.State + 'District',
            district: data.District + 'District',
            errorStatus: {
              ...prev.formone.errorStatus,
              country: false,
              states: false,
              district: false,
            },
            errorFields: {
              ...prev.formone.errorFields,
              country: '',
              states: '',
              district: '',
            },
          },
        }));
        if (previousState !== newState) {
          try {
            setBackdropOpen(true);
            const districtResponse = await getDistrictOptions({ codetype: newState });
            if (districtResponse.data) {
              setDistrictList(districtResponse.data);
            }
            setPreviousState(newState);
          } catch (error) {
            console.error('Error fetching districts:', error);
          } finally {
            setBackdropOpen(false);
          }
          setOptions(data?.City?.[0] ? data?.City : []);

          // Focus city field after successful fetch
          if (cityref.current) {
            cityref.current.focus();
          }
        }
      } catch (err) {
        showWarningSnackbar('Pincode does not exist in our database');
      }
    }
  }, []);
  function slideLeft() {
    setActiveStep((prev) => prev - 1);
  }
  // useEffect(() => {
  //   if (saveSkipStatus === true) return;

  //   if (saveSkipStatus === false && state.formone.pincode === 6) {
  //     handlePincodeChange(null, state.formone.pincode);
  //   }
  // }, [state.formone.pincode]);
  const handlePincodeKeyDown = useCallback((e) => {
    // Only allow numeric keys, backspace, delete, tab, escape, enter, and arrow keys
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    const isNumeric = /^[0-9]$/.test(e.key);
    const isAllowedKey = allowedKeys.includes(e.key);

    if (!isNumeric && !isAllowedKey) {
      e.preventDefault();
    }
  }, []);
  const getTimeStamp = (date) => {
    let SD = date
      ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
      : null;
    return Math.floor(new Date(SD).getTime() / 1000);
  };

  const formOneValidation = (data) => {
    let isValid = true;
    const obj = { ...state.formone };
    console.log(obj, 'ookkkk');

    const validations = {
      legalName: {
        message: 'Business Legal Name is required',
        regex: /^[a-zA-Z0-9.&' @_",()/-]*$/,
        validationMessage: 'Business Legal Name is Invalid',
        field: 'legalName',
      },
      shortName: {
        regex: /^[a-zA-Z0-9.&' @_",()/-]*$/,
        message: 'Invalid Business Brand/Short Name',
        validationMessage: 'Short Name is Invalid',
        field: 'shortName',
      },
      mobile: {
        regex: /^\+(?:\d\s?){6,14}\d$/,
        message: 'Mobile Number is required',
        validationMessage: 'Invalid Mobile Number',
        field: 'mobile',
      },
      website: {
        // regex: /^\+(?:\d\s?){6,14}\d$/,
        // message: 'Mobile Number is required',
        validationMessage: 'Invalid Website Link',
        field: 'website',
      },
      companyEmail: {
        regex: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        message: 'Email Address is Required',
        validationMessage: 'Invalid Email Address',
        field: 'companyEmail',
      },
      states: { message: 'State Name is required', field: 'states' },
      buisnessAddress: { message: 'Business Address is required', field: 'buisnessAddress' },
      district: { message: 'District Name is required', field: 'district' },
      city: { message: 'City is required', field: 'city' },
      pincode: {
        message: 'Pincode is required',
        regex: /^[1-9][0-9]{5}$/,
        validationMessage: 'Invalid Pincode format',
        field: 'pincode',
      },
    };

    Object.entries(data).forEach(([key, value]) => {
      const validation = validations[key];
      if (validation) {
        if (validation?.field !== 'pincode') {
          if (value?.trim()?.length === 0 && validation.field !== 'website') {
            obj.errorFields[validation.field] = validation.message;
            obj.errorStatus[validation.field] = true;
            isValid = false;
          } else {
            if (validation.field === 'legalName' || validation.field === 'shortName' || validation.field === 'companyEmail') {
              if (value?.trim().length > 0 && !validation?.regex?.test(value)) {
                obj.errorFields[validation.field] = validation.validationMessage;
                obj.errorStatus[validation.field] = true;
                isValid = false;
              } else {
                obj.errorFields[validation.field] = '';
                obj.errorStatus[validation.field] = false;
              }
            } else if (validation.field === 'mobile' || validation.field === 'website') {
              if (state.formone[validation.field] !== '' && state.formone.errorStatus[validation.field]) {
                obj.errorFields[validation.field] = validation.validationMessage;
                obj.errorStatus[validation.field] = true;
                isValid = false;
              } else {
                obj.errorFields[validation.field] = '';
                obj.errorStatus[validation.field] = false;
              }
            } else if (!value) {
              obj.errorFields[validation.field] = validation.message;
              obj.errorStatus[validation.field] = true;
              isValid = false;
            } else {
              obj.errorFields[validation.field] = '';
              obj.errorStatus[validation.field] = false;
            }
          }
        } else {
          // Special handling for pincode - check if empty or invalid format
          if (value.trim().length === 0) {
            obj.errorFields[validation.field] = validation.message;
            obj.errorStatus[validation.field] = true;
            isValid = false;
          } else if (value.trim().length > 0 && !validation?.regex?.test(value)) {
            obj.errorFields[validation.field] = validation.validationMessage;
            obj.errorStatus[validation.field] = true;
            isValid = false;
          } else {
            obj.errorFields[validation.field] = '';
            obj.errorStatus[validation.field] = false;
          }
        }
      }
    });

    setState((prev) => ({ ...prev, formone: obj }));

    return isValid;
  };

  const formTwoValidation = (data) => {
    let isValid = true;
    const obj = { ...state.formtwo };
    console.log(obj, 'obj');
    const patterns = {
      pan: /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/,
      gstin: /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}Z[0-9A-Za-z]{1}$/,
      dateRegex: /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
      tdsTcsRegex: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]$/,
    };

    Object.entries(data).forEach(([key, value]) => {
      let newDate = value?.$d;
      let newValue = newDate
        ? `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`
        : null;
      switch (key) {
        case 'registrationType':
          obj.errorFields.registrationType = value == 0 ? 'Registration Type is required' : '';
          obj.errorStatus.registrationType = value == 0;
          break;
        // case 'gstin':
        //   if ([2, 3, 4].includes(data['registrationType'])) {
        //     obj.errorFields.gstin = value?.trim().length === 15 && patterns.gstin?.test(value) ? '' : 'Invalid GSTIN';
        //     obj.errorStatus.gstin = value?.trim().length === 15 && patterns.gstin?.test(value) ? false : true;
        //     if (obj.gstin.length < 15 && patterns.gstin?.test(value)) {
        //       isValid = false; // Set isValid to false if there is a GSTIN error
        //     }
        //   }
        //   break;
        case 'CompositionRates':
          if (data['registrationType'] == 3) {
            obj.errorFields.CompositionRates = value == '' || value == null ? 'Composition Rate is required' : '';
            obj.errorStatus.CompositionRates = value == '' || value == null ? true : false;
            if (obj.errorFields.CompositionRates) {
              isValid = false; // Set isValid to false if there is a GSTIN error
            }
          }
          break;
        case 'pan':
          obj.errorFields.pan =
            data['registrationType'] == 1
              ? ''
              : ['2', '3', '4'].includes(String(data['registrationType'])) && value?.trim().length === 10 && patterns?.pan?.test(value)
              ? ''
              : 'Invalid PAN Number';
          obj.errorStatus.pan =
            data['registrationType'] == 1
              ? false
              : ['2', '3', '4'].includes(String(data['registrationType'])) && value.trim().length === 10 && patterns?.pan?.test(value)
              ? false
              : true;
          if (obj.errorFields.pan) {
            isValid = false; // Set isValid to false if there is a PAN error
          }
          break;
        case 'entityType':
          console.log(obj.errorFields.entityType, 'obj.errorFields.entityType');

          obj.errorFields.entityType = value.length === 0 ? 'Please select entity' : '';
          obj.errorStatus.entityType = value.length === 0;
          if (obj.errorFields.entityType) {
            isValid = false; // Set isValid to false if there is a PAN error
          }
          break;
        case 'lutBondNo':
        case 'lutValidFrom':
        case 'lutValidTo':
          obj.errorFields.lutValidFrom = data.lutBondNo !== '' && data.lutValidFrom === '' ? 'Please provide LUT valid from date' : '';
          obj.errorStatus.lutValidFrom = data.lutBondNo !== '' && data.lutValidFrom === '' ? true : false;
          if (obj.errorFields.lutValidFrom) {
            isValid = false; // Set isValid to false if there is a LUT validation error
          }
          break;

        // break;
        case 'tradeLicenseNo':
          obj.errorFields.tradeLicNoFromDate =
            data.tradeLicenseNo !== '' && data.tradeLicNoFromDate === '' ? 'Please provide Trade License valid from date' : '';
          obj.errorStatus.tradeLicNoFromDate = data.tradeLicenseNo !== '' && data.tradeLicNoFromDate === '' ? true : false;
          if (obj.errorFields.tradeLicNoFromDate) {
            isValid = false; // Set isValid to false if there is a Trade License validation error
          }
          break;

        case 'TDSTCSNumber':
          obj.errorFields.TDSTCSNumber =
            value === '' || (value !== '' && value?.trim().length === 10 && patterns?.tdsTcsRegex?.test(value))
              ? ''
              : 'Invalid TDS / TCS Number';
          obj.errorStatus.TDSTCSNumber =
            value === '' || (value !== '' && value.trim().length === 10 && patterns?.tdsTcsRegex?.test(value)) ? false : true;
          if (obj.errorFields.TDSTCSNumber) {
            isValid = false; // Set isValid to false if there is a PAN error
          }
          break;
        default:
          break;
      }
    });
    // Check if any field in errorStatus is true, then set isValid to false
    const hasErrors = Object.values(obj.errorStatus).some((error) => error === true);
    if (hasErrors) {
      isValid = false;
    }
    // console.log(hasErrors, 'hasErrors');

    setState((prev) => ({ ...prev, formtwo: obj }));
    return isValid;
  };
  const [comId, setComId] = useState('');
  useEffect(() => {
    if (BizData) {
      const newBusinessOptionsArr = [...BizData];

      newBusinessOptionsArr.push({
        businesstype: 'Add Business Type',
        value: 'Add Business Type',
        isactive: 0,
        restrictedflag: 1,
        id: 0,
      });
      setBusinessTypes(newBusinessOptionsArr);
    }
  }, [BizData]);
  useEffect(() => {
    if (IndData) {
      const newIndustryOptionsArr = [...IndData];

      newIndustryOptionsArr.push({
        industrytype: 'Add Industry Type',
        value: 'Add Industry Type',
        isactive: 0,
        restrictedflag: 1,
        id: 0,
      });
      setIndustryTypes(newIndustryOptionsArr);
    }
  }, [IndData]);
  async function getCompanyDetails() {
    setBackdropOpen(true);
    try {
      const docs = await API.graphql(
        graphqlOperation(getCompanyV2, {
          DocumentType: 'Company',
          PartyID: 0,
          StartDate: userPreferece.financialYear?.startdate,
          EndDate: userPreferece.financialYear?.enddate,
        })
      );

      setComId(companyDetails?.companyid);
      const validFrom =
        companyDetails.relatedcompanydetailsnew[0]?.lutbondvalidfrom !== 0
          ? moment(companyDetails.relatedcompanydetailsnew[0]?.lutbondvalidfrom * 1000).format('YYYY-MM-DD')
          : '';
      const currentDate = moment().format('YYYY-MM-DD');
      const daystoExpire = moment(companyDetails.relatedcompanydetailsnew[0]?.lutbondtodate * 1000).diff(
        validFrom <= currentDate ? moment() : moment(validFrom),
        'days'
      );
      const tradeValidFrom =
        companyDetails.relatedcompanydetailsnew[0]?.tradelicensestartdate !== 0
          ? moment(companyDetails.relatedcompanydetailsnew[0]?.tradelicensestartdate * 1000).format('YYYY-MM-DD')
          : '';

      const tradeValidTo =
        companyDetails.relatedcompanydetailsnew[0]?.tradelicenseenddate !== 0
          ? moment(companyDetails.relatedcompanydetailsnew[0]?.tradelicenseenddate * 1000).format('YYYY-MM-DD')
          : '';

      const validTo =
        companyDetails.relatedcompanydetailsnew[0]?.lutbondtodate !== 0
          ? moment(companyDetails.relatedcompanydetailsnew[0]?.lutbondtodate * 1000).format('YYYY-MM-DD')
          : '';
      const finEndDate = moment(validTo).format('YYYY-MM-DD');
      const daysDifference = moment(finEndDate).diff(moment(currentDate), 'days');

      setState((prev) => ({
        ...prev,
        formtwo: {
          ...prev.formtwo,
          lutBondNo: companyDetails.relatedcompanydetailsnew[0]?.lut,
          lutValidFrom: validFrom,
          lutValidTo: validTo,
          lutExpiry: daysDifference,
          tradeLicNoFromDate: tradeValidFrom,
          tradeLicNoToDate: tradeValidTo,
          ewayusername: companyDetails.ewaybillusername,
          // lutBondID: ele?.id,
        },
      }));
      setAttachments(docs.data.documents);
      setDocuments(docs.data.documents);
      console.log(docs?.data);

      const busData = await businessTypeFn(null, true);
      const indData = await IndustryTypeFn(null, true);
      const businesslistArr = busData?.data;
      // if (businesslistArr) {
      const updatedBusinessTypes = businesslistArr?.map((item) =>
        companyDetails.relatedcompanydetailsnew[0]?.businesstypeid?.includes(item.businesstypeid) ? { ...item, isactive: 1 } : item
      );
      setState((prev) => ({
        ...prev,
        formone: {
          ...prev.formone,
          buisnessType: [...updatedBusinessTypes].filter((bt) => bt.isactive === 1).map((bt) => bt.businesstype),
        },
      }));
      function ensureDistrict(name) {
        return /\bdistrict\b/i.test(name) ? name.trim() : `${name.trim()}district`;
      }

      const biz = [
        ...businesslistArr,
        {
          businesstype: 'Add Business Type',
          value: 'Add Business Type',
          isactive: 0,
          restrictedflag: 1,
          id: 0,
        },
      ];
      setBusinessTypes(biz);

      const IndustryListArr = indData?.data;

      const updatedIndustryTypes = IndustryListArr?.filter((item) =>
        companyDetails.relatedcompanydetailsnew[0]?.industrytypeid?.includes(item.industrytypeid)
      ).map((it) => it.industrytype);
      setState((prev) => ({
        ...prev,
        formone: {
          ...prev.formone,
          industryType: updatedIndustryTypes,
        },
      }));
      const indd = [
        ...IndustryListArr,
        {
          industrytype: 'Add Industry Type',
          value: 'Add Industry Type',
          isactive: 0,
          restrictedflag: 1,
          id: 0,
        },
      ];

      setIndustryTypes(indd);
      if (companyDetails != null) {
        setCompanyData(companyDetails);
        setCompanyLogo((prev) => ({
          ...prev,
          LOGOURL: companyDetails.relatedcompanydetailsnew[0]?.companylogourl,
        }));
        setState((prev) => ({
          ...prev,
          ['formone']: {
            ...prev.formone,
            companyLogo: companyDetails.relatedcompanydetailsnew[0]?.companylogourl,
          },
        }));
        if (companyDetails?.relatedcompanydetailsnew?.length > 0) {
          const relatedCompanyDetailsNew = companyDetails?.relatedcompanydetailsnew[0];

          const getFormattedDate = (dateTimeStamp) => {
            const momentObj = Number(dateTimeStamp) * 1000;
            return dayjs(moment(momentObj).format('YYYY-MM-DD'));
          };
          const gstApplicableDate =
            relatedCompanyDetailsNew?.gstapplicablefrom !== 0 ? getFormattedDate(relatedCompanyDetailsNew?.gstapplicablefrom) : null;
          const CINRegistrationDate =
            relatedCompanyDetailsNew?.cinregistrationdate !== 0 ? getFormattedDate(relatedCompanyDetailsNew?.cinregistrationdate) : null;
          const ewyBillDate =
            relatedCompanyDetailsNew?.ewaybillstartdate !== 0 ? getFormattedDate(relatedCompanyDetailsNew?.ewaybillstartdate) : null;
          const eInvoiceDate =
            relatedCompanyDetailsNew?.einvoicestartingdate !== 0 ? getFormattedDate(relatedCompanyDetailsNew?.einvoicestartingdate) : null;

          const getDateFormatted = (timestamp) => {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
          };
          let tradelicExpiry = '';
          if (relatedCompanyDetailsNew?.tradelicensestartdate !== 0 && relatedCompanyDetailsNew?.tradelicenseenddate !== 0) {
            const validFrom = getDateFormatted(relatedCompanyDetailsNew?.tradelicensestartdate * 1000);
            const validTo = getDateFormatted(relatedCompanyDetailsNew?.tradelicenseenddate * 1000);
            const currentDate = moment().format('YYYY-MM-DD');
            tradelicExpiry = moment(validTo).diff(validFrom <= currentDate ? moment() : moment(validFrom), 'days');
          }
          // if (companyLogo.LogoName != 0)

          setState((prev) => ({
            ...prev,
            ['formone']: {
              ...prev.formone,
              legalName: String(companyDetails?.companyname),
              shortName: String(relatedCompanyDetailsNew?.companyshort),
              currency: relatedCompanyDetailsNew?.currencycd == 0 ? '1' : String(relatedCompanyDetailsNew?.currencycd),
              website: relatedCompanyDetailsNew?.websiteurl,
              // city: relatedCompanyDetailsNew?.city ? relatedCompanyDetailsNew?.city : 'kozhicode',
              status: true,
            },
            ['formtwo']: {
              ...prev.formtwo,
              registrationType: Number(relatedCompanyDetailsNew?.registrationtype),
              CompositionRates: relatedCompanyDetailsNew?.comppercentage,
              gstApplicableDate: relatedCompanyDetailsNew?.gstapplicablefrom === 0 ? '' : gstApplicableDate,
              eWayBill: relatedCompanyDetailsNew?.ewaybillflag,
              pan: relatedCompanyDetailsNew?.pannumber,
              TDSTCSNumber: relatedCompanyDetailsNew?.tdstcsnumber,
              cinRegNo: relatedCompanyDetailsNew?.cinregistrationnumber,
              cinRegDate: relatedCompanyDetailsNew?.cinregistrationdate === 0 ? '' : CINRegistrationDate,
              udhyamRegNo: relatedCompanyDetailsNew?.udhyamregno !== '' ? relatedCompanyDetailsNew?.udhyamregno : '',

              msmeType: relatedCompanyDetailsNew?.msmetype !== '' ? relatedCompanyDetailsNew?.msmetype : '',
              gstReturnPeriod: relatedCompanyDetailsNew?.gstrperiod,
              ewayBillStartDate: relatedCompanyDetailsNew?.ewaybillstartdate === 0 ? '' : ewyBillDate,
              eWayBillInterStateAmount: relatedCompanyDetailsNew?.minamountewayinter,
              eWayBillIntraStateAmount: relatedCompanyDetailsNew?.minamountewayintra,
              eInvoicing: relatedCompanyDetailsNew?.einvoiceflag,
              eInvoiceStartDate: relatedCompanyDetailsNew?.einvoicestartingdate === 0 ? '' : eInvoiceDate,
              gstCessFlag: relatedCompanyDetailsNew?.gstcompensationcessflag,
              connect: relatedCompanyDetailsNew?.einvoiceconnect,
              ewayconnect: relatedCompanyDetailsNew?.ewaybillconnect,
              tradeLicenseNo: relatedCompanyDetailsNew?.tradelicensenumber !== '' ? relatedCompanyDetailsNew?.tradelicensenumber : '',
              // tradeLicNoFromDate: relatedCompanyDetailsNew?.tradelicensestartdate === 0 ? '' : tradeLicFromDate,
              // tradeLicNoToDate: relatedCompanyDetailsNew?.tradelicenseenddate === 0 ? '' : tradeLicToDate,
              expiresin: tradelicExpiry !== '' ? tradelicExpiry : '',
            },
          }));
        }

        if (companyDetails?.relatedcompanyentity?.length > 0) {
          setState((prev) => ({
            ...prev,
            ['formtwo']: {
              ...prev.formtwo,
              gstin: companyDetails?.relatedcompanyentity[0]?.gstin,
              entityType: companyDetails?.relatedcompanyentity[0]?.companyentitytype,
              username: companyDetails?.einvoiceusername ? companyDetails?.einvoiceusername : state.formtwo.username,
            },
          }));
        }
        setState((prev) => ({
          ...prev,
          ['formone']: {
            ...prev.formone,
            companyEmail: companyDetails?.relatedemailcontacts[0]?.emailaddress,
          },
        }));

        setState((prev) => ({
          ...prev,
          ['formone']: {
            ...prev.formone,
            mobile: companyDetails?.relatedphonecontacts[0]?.phonenumber,
          },
        }));
        if (companyDetails?.relatedaddressentity?.length > 0) {
          const address = companyDetails?.relatedaddressentity[0]?.line1.split('**') || [];
          let element = '';
          if (companyDetails?.relatedaddressentity[0]?.line1 !== '') {
            for (let index = 0; index < address.length; index++) {
              element += address[index] + '\n';
            }
          }

          setState((prev) => ({
            ...prev,
            ['formone']: {
              ...prev.formone,
              states: companyDetails?.statename ? companyDetails?.statename + 'District' : '',

              district: companyDetails?.relatedaddressentity[0]?.district
                ? ensureDistrict(companyDetails?.relatedaddressentity[0]?.district)
                : '',
              pincode: companyDetails?.relatedaddressentity[0]?.pincode,
              country:
                companyDetails?.relatedaddressentity[0]?.countrycode === ''
                  ? 'IndiaState'
                  : companyDetails?.relatedaddressentity[0]?.countrycode,
              buisnessAddress: element,
              city: companyDetails?.relatedaddressentity[0]?.city || '',
            },
          }));
        }
        // }
      }
      if (
        !companyDetails?.relatedaddressentity[0]?.district &&
        saveSkipStatus === false &&
        companyDetails?.relatedaddressentity[0]?.pincode
      ) {
        handlePincodeChange(null, companyDetails?.relatedaddressentity[0]?.pincode);
      }
    } catch (error) {
      console.log('error in getDistricts ::: ', error);
      setBackdropOpen(false);
    } finally {
      setBackdropOpen(false);
      // setInitialLoadingComplete(true); // Mark initial loading as complete
    }
  }
  console.log(stateList, 'stateList');

  useEffect(() => {
    getCompanyDetails();
  }, []);

  // Effect to call district API when state exists but district is empty
  useEffect(() => {
    const fetchDistrictsForExistingState = async () => {
      // debugger;
      // Check if we have state but no district in the company data
      if (state.formone.states) {
        try {
          const districtResponse = await getDistrictOptions({ codetype: state.formone.states });
          if (districtResponse.data) {
            setDistrictList(districtResponse.data);
          }
          setPreviousState(state.formone.states);
        } catch (error) {
          console.error('Error fetching districts for company state:', error);
        }
      }
    };

    // Only run this effect when initial loading is complete and we have state data
    if (state.formone.states) {
      fetchDistrictsForExistingState();
    }
  }, [state.formone.states]);

  async function addComapnyEntity(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createcompanyentity, {
          createcompanyentityInput: data,
        })
      );
    } catch (error) {
      console.log(error);
    }
  }
  async function addAddress(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createPartyAddressEntity, {
          createPartyAddressEntityInput: data,
        })
      );
      // cityref.current.focus()
      if (cityref.current) {
        cityref.current.focus();
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function addCompanyData(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createcompanydetails, {
          createCompanyDetailsInput: [data],
        })
      );
    } catch (error) {
      console.log(error);
    }
    return true;
  }
  const financialYearId = useSelector((state) => state?.userPrefrenceandReducer?.financialYear?.financialyearid);
  console.log(state.formtwo, 'eeee');

  async function addDocuments(data) {
    try {
      const resMsmeattachments = await API.graphql(
        graphqlOperation(createCompanyDocuments, {
          createCompanyDocumentsInput: data,
        })
      );
      const filteredAttach = resMsmeattachments.data.createCompanyDocuments.filter((att) => att.expiredtimestamp === 0);
      setAttachments(filteredAttach);
    } catch (error) {
      console.log('error', error);
    }
  }

  const formOneFocus = () => {
    if (state.formone.errorStatus?.legalName && legalref.current) {
      legalref.current.focus();
    } else if (state.formone.errorStatus?.shortName && shortref.current) {
      shortref.current.focus();
    } else if (state.formone.errorStatus?.companyEmail && mailref.current) {
      mailref.current.focus();
    } else if (state.formone.errorStatus?.mobile && mobileref.current) {
      mobileref.current.focus();
    } else if (state.formone.errorStatus?.website && webref.current) {
      webref.current.focus();
    } else if (state.formone.errorStatus?.country && countryref.current) {
      countryref.current.focus();
    } else if (state.formone.errorStatus?.pincode && pincoderef.current) {
      pincoderef.current.focus();
    } else if (state.formone.errorStatus?.district && districtref.current) {
      districtref.current.focus();
    } else if (state.formone.errorStatus?.city && cityref.current) {
      cityref.current.focus();
    } else if (state.formone.errorStatus?.states && stateref.current) {
      stateref.current.focus();
    } else if (stateref?.current === null || !stateref?.current?.value) {
      stateref?.current?.focus();
    } else if (districtref?.current === null || districtref?.current?.value === '') {
      districtref?.current?.focus();
    }
  };

  const formTwoFocus = () => {
    if (state.formtwo.registrationType != 1 && state.formtwo.gstin.length < 15) {
      gstinref.current && gstinref.current.focus();
    } else if (state.formtwo.registrationType != 1 && state.formtwo.pan === '') {
      panref.current && panref.current.focus();
    } else if (state.formtwo.entityType === '') {
      entityRef.current && entityRef.current.focus();
    } else if (state.formtwo.errorStatus?.TDSTCSNumber) {
      tanref.current && tanref.current.focus();
    } else if (state.formtwo.errorStatus?.username) {
      usernameRef.current && usernameRef.current.focus();
    } else if (state.formtwo.errorStatus?.lutValidFrom) {
      lutFrom.current && lutFrom.current.focus();
      setState((prev) => ({
        ...prev,
        ['formtwo']: {
          ...prev['formtwo'],
          errorStatus: {
            ...prev['formtwo'].errorStatus,
            ['lutValidFrom']: true,
          },
          errorFields: {
            ...prev['formtwo'].errorFields,
            ['lutValidFrom']: 'LUT Valid From Date required ',
          },
        },
      }));
    } else if (state.formtwo.errorStatus?.lutValidTo) {
      lutTo.current && lutTo.current.focus();
      setState((prev) => ({
        ...prev,
        ['formtwo']: {
          ...prev['formtwo'],
          errorStatus: {
            ...prev['formtwo'].errorStatus,
            ['lutValidTo']: true,
          },
          errorFields: {
            ...prev['formtwo'].errorFields,
            ['lutValidTo']: 'LUT Valid To Date required ',
          },
        },
      }));
    } else if (state.formtwo.errorStatus?.tradeLicNoFromDate || (state.formtwo.tradeLicenseNo && state.formtwo.tradeLicNoFromDate === '')) {
      tradeFrom.current && tradeFrom.current.focus();
    } else if (state.formtwo.errorStatus?.tradeLicNoToDate) {
      tradeTo.current && tradeTo.current.focus();
    } else if (state.formtwo.registrationType == 3 && (state.formtwo.CompositionRates == null || state.formtwo.CompositionRates == 0)) {
      compref.current && compref?.current?.focus();
    }
  };
  const initialSettingsBool =
    partyBool === true ||
    state.formtwo.eInvoicing != companyDetails.relatedcompanydetailsnew[0]?.einvoiceflag ||
    state.formtwo.eWayBill != companyDetails.relatedcompanydetailsnew[0]?.ewaybillflag;
  const [settingsBool, setSettingsBool] = useState(initialSettingsBool); // Initialize as true
  console.log(state.formone, 'statebbbbbbb');

  const statecode = stateList && stateList.length > 0 && stateList.find((f) => f.value === state.formone.states)?.code;
  const setSettingsBoolFalse = useCallback(() => {
    if (settingsBool !== false) {
      setSettingsBool(false);
    }
  }, []);
  const buztypes = businessTypes
    .filter((item) => state.formone.buisnessType.includes(item.businesstype))
    .map((item) => item.businesstypeid);
  const Indtypes = industryTypes
    .filter((item) => state.formone.industryType.includes(item.industrytype))
    .map((item) => item.industrytypeid);
  console.log(buztypes, 'buztypes');
  const compBizData = companyDetails?.relatedcompanydetailsnew?.[0]?.businesstypeid;
  const compIndData = companyDetails?.relatedcompanydetailsnew?.[0]?.industrytypeid;
  const bizBool =
    !compBizData && !buztypes ? true : buztypes?.length === compBizData?.length && buztypes?.every((num) => compBizData?.includes(num));
  const IndBool =
    !compIndData && !Indtypes ? true : Indtypes?.length === compIndData?.length && Indtypes?.every((num) => compIndData?.includes(num));
  console.log(IndBool, 'IndBool');

  const handleSteps = async (event, step, upper) => {
    setEditMode(true);
    formOneFocus();
    if (step === 0) {
      if (editableValue !== '') {
        setEditableValue('');
      }
      setActiveStep(0);
      setChangedValues([]);
    } else if (step === 1) {
      dispatch(fetchCompany());
      if (activeStep === 0) {
        const {
          legalName,
          shortName,
          buisnessAddress,
          country,
          states,
          district,
          pincode,
          city,
          mobile,
          companyEmail,
          website,
          buisnessType,
          industryType,
          currency,
        } = state.formone;

        const formOneData = {
          legalName,
          shortName,
          buisnessAddress,
          country,
          states,
          district,
          city,
          pincode,
          mobile,
          companyEmail,
          website,
          buisnessType,
          industryType,
          currency,
        };

        if (formOneValidation(formOneData)) {
          setBackdropOpen(true);
          if (companyLogo?.LogoName != 0) {
            const response = await uploadToServer(companyLogo.file, companyLogo.LogoName, companyLogo.Type);
          }
          const addressEntityData = {
            objecttype: 'COMPANY',
            objectid: companyDetails?.companyid,
            expiredtimestamp: 0,
            line1: state?.formone?.buisnessAddress.trim(),
            line2: '',
            line3: '',
            city: state.formone.city ? state.formone.city : '',
            statecode: statecode ? statecode : companyData?.relatedaddressentity[0]?.statecode,
            pincode: state.formone.pincode,
            countrycode: state.formone.country,
            district: state?.formone?.district.replace('district', '').replace('District', ''),
            financialyearid: userPreferece?.financialYear?.financialyearid,
          };
          let validFromLUT =
            state?.formtwo?.lutValidFrom === ''
              ? 0
              : state?.formtwo?.lutValidFrom !== 0 && typeof state?.formtwo?.lutValidFrom !== 'string'
              ? getTimeStamp(state?.formtwo?.lutValidFrom?.$d)
              : typeof companyData?.relatedcompanydetailsnew[0]?.lutbondvalidfrom === 'number' &&
                companyData?.relatedcompanydetailsnew[0]?.lutbondvalidfrom !== 0 &&
                companyData?.relatedcompanydetailsnew[0]?.lutbondvalidfrom;

          let tradeValidFrom =
            state?.formtwo?.tradeLicNoFromDate === ''
              ? 0
              : getTimeStamp(state?.formtwo?.tradeLicNoFromDate?.$d) !== 0
              ? getTimeStamp(state?.formtwo?.tradeLicNoFromDate?.$d)
              : companyData?.relatedcompanydetailsnew[0]?.tradelicensestartdate;

          let validToLUT =
            state?.formtwo?.lutValidTo === ''
              ? 0
              : getTimeStamp(state?.formtwo?.lutValidTo?.$d) !== 0
              ? getTimeStamp(state?.formtwo?.lutValidTo?.$d)
              : companyData?.relatedcompanydetailsnew[0]?.lutbondtodate;

          let validCin =
            state?.formtwo?.cinRegDate === ''
              ? 0
              : getTimeStamp(state?.formtwo?.cinRegDate?.$d) !== 0
              ? getTimeStamp(state?.formtwo?.cinRegDate?.$d)
              : companyData?.relatedcompanydetailsnew[0]?.cinregistrationdate;

          let tradeValidTo =
            state?.formtwo?.tradeLicNoToDate === ''
              ? 0
              : getTimeStamp(state?.formtwo?.tradeLicNoToDate?.$d) !== 0
              ? getTimeStamp(state?.formtwo?.tradeLicNoToDate?.$d)
              : companyData?.relatedcompanydetailsnew[0]?.tradelicenseenddate;

          const companyFormData = {
            companyshort: state.formone.shortName,
            companylegalname: state.formone.legalName,
            einvoiceconnect: state.formtwo.connect ? state.formtwo.connect : 0,
            lutbondtodate: validToLUT,
            invoicedetailapplicablefromdate: 0,
            tdsapplicable: 0,
            gstcategory: Number(state.formtwo.registrationType),
            financialyearid: financialYearId,
            financialyearstartandendmonth: 0,
            expiredtimestamp: 0,
            websiteurl: state.formone.website.trim(),
            currencycd: Number(state.formone.currency),
            accountinventoryflag: 0,
            emailaddress: state.formone.companyEmail,
            phonenumber: state.formone.mobile,
            pannumber: state.formtwo.pan,
            tdstcsnumber: state.formtwo.TDSTCSNumber,
            cinregistrationnumber: state.formtwo.cinRegNo,
            registrationtype: Number(state.formtwo.registrationType),
            comppercentage: state.formtwo.CompositionRates ? state.formtwo.CompositionRates : 0,
            gstrperiod: state.formtwo.gstReturnPeriod,
            lut: state.formtwo.lutBondNo,
            lutbondvalidfrom: validFromLUT,
            ewaybillflag: state.formtwo.eWayBill ? Number(state.formtwo.eWayBill) : 0,
            gstapplicablefrom: state.formtwo.gstApplicableDate ? getTimeStamp(state.formtwo.gstApplicableDate?.$d) : 0,
            thresholdlimitcd: 0,
            thresholdlimitamount: 0.0,
            companylogourl:
              companyLogo.LOGOURL !== '' && companyLogo.LOGOURL !== state.formone.companyLogo
                ? `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${companyLogo?.LogoName}`
                : companyLogo.LOGOURL,
            msmetype: state.formtwo.msmeType,
            udhyamregno: state.formtwo.udhyamRegNo,
            udhyamdocs: '',
            ewaybillstartdate: state.formtwo.ewayBillStartDate ? state.formtwo.ewayBillStartDate : 0,
            minamountewayinter: state.formtwo.eWayBillInterStateAmount ? state.formtwo.eWayBillInterStateAmount : 0,
            minamountewayintra: state.formtwo.eWayBillIntraStateAmount ? state.formtwo.eWayBillIntraStateAmount : 0,
            einvoiceflag: state.formtwo.eInvoicing ? state.formtwo.eInvoicing : 0,
            einvoicestartingdate: state.formtwo.eInvoiceStartDate ? state.formtwo.eInvoiceStartDate : 0,
            gstcompensationcessflag: state.formtwo.gstCessFlag ? state.formtwo.gstCessFlag : 0,
            tradelicensenumber: state.formtwo.tradeLicenseNo,
            tradelicensestartdate: tradeValidFrom,
            tradelicenseenddate: state.formtwo.tradeLicNoToDate ? tradeValidTo : 0,
            cinregistrationdate: validCin,
            lastupdatedtimestamp: 0,
            ewaybillconnect: state.formtwo.ewayconnect ? state.formtwo.ewayconnect : 0,
            stepscompleted: !companyData?.relatedcompanydetailsnew[0]?.stepscompleted
              ? JSON.stringify(['step 1'])
              : JSON.stringify(companyData?.relatedcompanydetailsnew[0]?.stepscompleted),
            businesstypeid: buztypes,
            industrytypeid: Indtypes,
          };
          let step1loc = false;

          // const isSubset = haveSameElements(state.formone.buisnessType, buztypes) === true ? false : true;
          // const indtypes = industrylist.filter((b) => b.isactive === 1).map((b) => b.industrytype);
          // const isSubset2 = haveSameElements(state.formone.industryType, indtypes) === true ? false : true;

          // if (isSubset) {
          //   step1loc = true;
          //   await updateSelectedBusinessType();
          // }
          // if (isSubset2) {
          //   step1loc = true;
          //   await updateSelectedIndustryType();
          // }

          if (
            companyData?.relatedcompanydetailsnew[0]?.companyshort !== state.formone.shortName ||
            companyData?.relatedcompanydetailsnew[0]?.companylegalname !== state.formone.legalName ||
            companyData?.relatedcompanydetailsnew[0]?.websiteurl !== state.formone.website.trim() ||
            companyLogo.LOGOURL !== state.formone.companyLogo ||
            companyData?.relatedemailcontacts[0]?.emailaddress !== state.formone.companyEmail ||
            companyData?.relatedphonecontacts[0]?.phonenumber !== state.formone.mobile ||
            companyData?.relatedcompanydetailsnew[0]?.stepscompleted?.includes('step 2') === false ||
            companyData?.relatedcompanydetailsnew[0]?.stepscompleted === null ||
            bizBool === false ||
            IndBool === false
          ) {
            step1loc = true;
            await addCompanyData(companyFormData);
          }
          if (
            companyData?.relatedaddressentity[0]?.line1 !== state?.formone?.buisnessAddress.trim() ||
            companyData?.relatedaddressentity[0]?.city !== state.formone.city ||
            companyData?.relatedaddressentity[0]?.pincode != state.formone.pincode ||
            companyData?.relatedaddressentity[0]?.countrycode !== state.formone.country ||
            companyData?.relatedaddressentity[0]?.district.replace(/district/i, '').toUpperCase() !==
              state?.formone?.district.replace(/district/i, '').toUpperCase() ||
            saveSkipStatus === false
          ) {
            step1loc = true;
            await addAddress(addressEntityData);
          }
          if (editableValue !== '') {
            setEditableValue('');
          }

          setActiveStep(1);

          if (step1loc) {
            showSuccessSnackbar('Changes saved successfully');
            dispatch(fetchCompany());
            if (snapshotTaken) {
              setInitialStateSnapshot(JSON.parse(JSON.stringify(state)));
            }
          } else if (upper === false) {
            showSuccessSnackbar('No changes made');
          }
          dispatch(setCompanyName(state?.formone?.shortName));
          step1loc = false;
          setBackdropOpen(false);
          dispatch(setNavigationBlocked(false));
        } else {
          const hasTrueValue = Object.values(state.formone.errorStatus).some((value) => value === true);
          const trueKeys = Object.keys(state.formone.errorStatus).filter((k) => state.formone.errorStatus[k] === true);
          const labels = trueKeys.map(humanizeKey);

          if (hasTrueValue && activeStep === 0) {
            showWarningSnackbar('Please fill ' + labels.map((g) => ' ' + g));
            return;
          }
        }
      } else {
        setActiveStep(1);
        setBackdropOpen(false);
      }
      setUpdatePassword(false);
      setEwayUpdatePassword(false);
    } else if (step === 2) {
      const {
        legalName,
        shortName,
        buisnessAddress,
        country,
        states,
        district,
        city,
        pincode,
        mobile,
        companyEmail,
        website,
        buisnessType,
        industryType,
        currency,
      } = state.formone;

      const formOneData = {
        legalName,
        shortName,
        buisnessAddress,
        country,
        states,
        district,
        city,
        pincode,
        mobile,
        companyEmail,
        website,
        buisnessType,
        industryType,
        currency,
      };

      const {
        registrationType,
        gstin,
        gstApplicableDate,
        gstReturnPeriod,
        ewayBillStartDate,
        eWayBillInterStateAmount,
        eWayBillIntraStateAmount,
        eInvoiceStartDate,
        lutValidFrom,
        lutValidTo,
        pan,
        lutBondNo,
        TDSTCSNumber,
        CompositionRates,
        entityType,
        cinRegNo,
        cinRegDate,
        tradeLicenseNo,
        tradeLicNoFromDate,
        tradeLicNoToDate,
        msmeType,
        udhyamRegNo,
      } = state.formtwo;
      const formTwoData = {
        registrationType,
        gstin,
        gstApplicableDate,
        CompositionRates,
        gstReturnPeriod,
        ewayBillStartDate,
        eWayBillInterStateAmount,
        eWayBillIntraStateAmount,
        eInvoiceStartDate,
        lutValidFrom,
        lutValidTo,
        pan,
        lutBondNo,
        TDSTCSNumber,
        entityType,
        cinRegNo,
        cinRegDate,
        tradeLicenseNo,
        tradeLicNoFromDate,
        tradeLicNoToDate,
        msmeType,
        udhyamRegNo,
      };

      if (formTwoValidation(formTwoData) && formOneValidation(formOneData)) {
        setBackdropOpen(true);
        Math.floor(new Date().getTime() / 1000);
        const exp = Math.floor(new Date().getTime() / 1000);
        const idsInArray2 = new Set(attachments.map((item) => item.id));
        let arratt = [];
        const updatedArray1 = documents.map((item) => {
          let arr;
          if (!idsInArray2.has(item.id) && typeof item.id !== 'string') {
            arr = { ...item, expiredtimestamp: exp };
            arratt.push(arr);
          } else {
            // arr = attachments[item.attachmentid] || item;
            arr = attachments.find((att) => att.id === item.id);
            arratt.push(arr);
          }
        });
        const additionalItems = attachments.filter((item2) => !documents.some((item1) => item1.id === item2.id));
        let apiDocCheck = false;
        let apiDocCheck2 = false;
        let apiEinvCheck = false;
        let apiEwayCheck = false;
        const finalArray = [...arratt, ...additionalItems];
        const attachedArr = finalArray.map((ele) => ({
          partyid: 0,
          id: typeof ele.id === 'string' ? 0 : ele.id,
          documenttype: 'Company',
          documentname: ele.documentname,
          imagename: ele.imagename,
          imageurl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`,
          type: ele?.type,
          expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
          isactive: 0,
        }));
        try {
          let responses = finalArray.map((element) => {
            if (element?.file) {
              apiDocCheck = true;
              return uploadToServer(element.file, element.imagename, element.type);
            }
          });
          let response = await Promise.all(responses);
          // setDocuments([]);
          let updateCred = false;
          if (companyDetails.relatedcompanydetailsnew[0].einvoiceconnect !== 1 && state.formtwo.connect == 1) {
            apiEinvCheck = true;
            // await EinvoiceBlur();
            const payload = {
              action: 'updateCredentials',
              data: {
                userName: state.formtwo.username.trim(),
                password: state.formtwo.password.trim(),
              },
            };
            const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EINVOICE_URL, payload);
            updateState('formtwo', 'password', '', false, '');
          } else if (companyDetails.relatedcompanydetailsnew[0].einvoiceconnect == 1 && state.formtwo.connect == 0) {
            updateCred = true;
            const payload = {
              action: 'updateCredentials',
              data: {
                userName: '',
                password: '',
              },
            };
            showWarningSnackbar('E invoice username and password not saved');
            const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EINVOICE_URL, payload);
            updateState('formtwo', 'password', '', false, '');
            updateState('formtwo', 'username', '', false, '');
          }
          if (companyDetails.relatedcompanydetailsnew[0].ewaybillconnect != 1 && state.formtwo.ewayconnect == 1) {
            apiEwayCheck = true;

            const payload = {
              action: 'updateCredentials',
              data: {
                userName: state.formtwo.ewayusername.trim(),
                password: state.formtwo.ewaypassword.trim(),
              },
            };
            // try {
            const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
            updateState('formtwo', 'ewaypassword', '', false, '');
          } else if (companyDetails.relatedcompanydetailsnew[0].ewaybillconnect === 1 && state.formtwo.ewayconnect == 0) {
            updateCred = true;
            const payload = {
              action: 'discardCredentials',
              data: {
                userName: '',
                password: '',
              },
            };
            // try {
            showWarningSnackbar('E way bill username and password not saved');
            const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
            updateState('formtwo', 'ewaypassword', '', false, '');
            updateState('formtwo', 'ewayusername', '', false, '');
          }
          const checkdoc = documents.every((doc, index) => doc.documentname === attachments[index]?.documentname);

          if (apiDocCheck === true || checkdoc === false) {
            apiDocCheck2 = true;
            await addDocuments(attachedArr);
          }
          if (updateCred) {
            await dispatch(fetchCompany());
            updateCred = false;
          }
          let validFromLUT =
            state?.formtwo?.lutValidFrom === ''
              ? 0
              : getTimeStamp(state?.formtwo?.lutValidFrom?.$d) !== 0
              ? getTimeStamp(state?.formtwo?.lutValidFrom?.$d)
              : companyData?.relatedcompanydetailsnew[0]?.lutbondvalidfrom;

          let tradeValidFrom =
            state?.formtwo?.tradeLicNoFromDate === ''
              ? 0
              : state?.formtwo?.tradeLicNoFromDate !== 0 && typeof state?.formtwo?.tradeLicNoFromDate !== 'string'
              ? getTimeStamp(state?.formtwo?.tradeLicNoFromDate?.$d)
              : typeof companyData?.relatedcompanydetailsnew[0]?.tradelicensestartdate === 'number' &&
                companyData?.relatedcompanydetailsnew[0]?.tradelicensestartdate !== 0
              ? companyData?.relatedcompanydetailsnew[0]?.tradelicensestartdate
              : state?.formtwo?.tradeLicNoFromDate.trim() === ''
              ? 0
              : state?.formtwo?.tradeLicNoFromDate;

          let validToLUT =
            state?.formtwo?.lutValidTo === ''
              ? 0
              : state?.formtwo?.lutValidTo !== 0 && typeof state?.formtwo?.lutValidTo !== 'string'
              ? getTimeStamp(state?.formtwo?.lutValidTo?.$d)
              : typeof companyData?.relatedcompanydetailsnew[0]?.lutbondtodate === 'number' &&
                companyData?.relatedcompanydetailsnew[0]?.lutbondtodate !== 0 &&
                companyData?.relatedcompanydetailsnew[0]?.lutbondtodate;

          let validCin =
            state?.formtwo?.cinRegDate === ''
              ? 0
              : state?.formtwo?.cinRegDate !== 0 && typeof state?.formtwo?.cinRegDate !== 'string'
              ? getTimeStamp(state?.formtwo?.cinRegDate?.$d)
              : typeof companyData?.relatedcompanydetailsnew[0]?.cinregistrationdate === 'number' &&
                companyData?.relatedcompanydetailsnew[0]?.cinregistrationdate !== 0 &&
                companyData?.relatedcompanydetailsnew[0]?.cinregistrationdate;

          let tradeValidTo =
            state?.formtwo?.tradeLicNoToDate === ''
              ? 0
              : state?.formtwo?.tradeLicNoToDate !== 0 && typeof state?.formtwo?.tradeLicNoToDate !== 'string'
              ? getTimeStamp(state?.formtwo?.tradeLicNoToDate?.$d)
              : typeof companyData?.relatedcompanydetailsnew[0]?.tradelicenseenddate === 'number' &&
                companyData?.relatedcompanydetailsnew[0]?.tradelicenseenddate !== 0 &&
                companyData?.relatedcompanydetailsnew[0]?.tradelicenseenddate;
          const companyEntityData = {
            expiredtimestamp: 0,
            gstin: state.formtwo.gstin,
            financialyearcode: '2024',
            financialyearid: financialYearId,
            companyentitytype: state.formtwo.entityType,
            legalname: state.formone.legalName,
            startdate: 0,
          };
          let entityCheck = false;
          if (
            companyData?.relatedcompanyentity[0]?.gstin !== state.formtwo.gstin ||
            companyData?.relatedcompanyentity[0]?.companyentitytype !== state.formtwo.entityType
          ) {
            entityCheck = true;
            await addComapnyEntity(companyEntityData);
          }
          const companyFormData = {
            companyshort: state.formone.shortName,
            companylegalname: state.formone.legalName,
            einvoiceconnect: state.formtwo.connect ? state.formtwo.connect : 0,
            lutbondtodate: validToLUT,
            invoicedetailapplicablefromdate: 0,
            tdsapplicable: 0,
            gstcategory: state.formtwo.registrationType,
            financialyearstartandendmonth: 0,
            expiredtimestamp: 0,
            financialyearid: financialYearId,
            websiteurl: state.formone.website.trim(),
            currencycd: Number(state.formone.currency),
            accountinventoryflag: 0,
            pannumber: state.formtwo.pan,
            emailaddress: state.formone.companyEmail,
            phonenumber: state.formone.mobile,
            tdstcsnumber: state.formtwo.TDSTCSNumber,
            cinregistrationnumber: state.formtwo.cinRegNo,
            registrationtype: Number(state.formtwo.registrationType),
            comppercentage: state.formtwo.CompositionRates ? state.formtwo.CompositionRates : 0,
            gstrperiod: state.formtwo.gstReturnPeriod,
            lut: state.formtwo.lutBondNo,
            lutbondvalidfrom: validFromLUT,
            ewaybillflag: state.formtwo.eWayBill ? Number(state.formtwo.eWayBill) : 0,
            gstapplicablefrom: state.formtwo.gstApplicableDate ? getTimeStamp(state.formtwo.gstApplicableDate?.$d) : 0,
            thresholdlimitcd: 0,
            thresholdlimitamount: 0.0,
            companylogourl: state.formone.companyLogo,
            msmetype: state.formtwo.msmeType,
            udhyamregno: state.formtwo.udhyamRegNo,
            udhyamdocs: '',
            ewaybillstartdate: state.formtwo.ewayBillStartDate ? state.formtwo.ewayBillStartDate : 0,
            minamountewayinter: state.formtwo.eWayBillInterStateAmount ? state.formtwo.eWayBillInterStateAmount : 0,
            minamountewayintra: state.formtwo.eWayBillIntraStateAmount ? state.formtwo.eWayBillIntraStateAmount : 0,
            einvoiceflag: state.formtwo.eInvoicing ? state.formtwo.eInvoicing : 0,
            einvoicestartingdate: state.formtwo.eInvoiceStartDate ? state.formtwo.eInvoiceStartDate : 0,
            gstcompensationcessflag: state.formtwo.gstCessFlag ? state.formtwo.gstCessFlag : 0,
            tradelicensenumber: state.formtwo.tradeLicenseNo,
            tradelicensestartdate: tradeValidFrom,
            tradelicenseenddate: tradeValidTo,
            cinregistrationdate: validCin,
            lastupdatedtimestamp: 0,
            ewaybillconnect: state.formtwo.ewayconnect ? state.formtwo.ewayconnect : 0,
            stepscompleted: JSON.stringify(['step 1', 'step 2']),
          };
          let mainapicheck = false;
          if (
            !companyData?.relatedcompanydetailsnew[0]?.stepscompleted?.includes('step 2') ||
            companyData?.relatedcompanydetailsnew[0]?.einvoiceconnect !== state.formtwo.connect ||
            companyData?.relatedcompanydetailsnew[0]?.lutbondtodate !== validToLUT ||
            companyData?.relatedcompanydetailsnew[0]?.gstcategory != state.formtwo.registrationType ||
            companyData?.relatedcompanydetailsnew[0]?.pannumber !== state.formtwo.pan ||
            companyData?.relatedcompanydetailsnew[0]?.tdstcsnumber !== state.formtwo.TDSTCSNumber ||
            companyData?.relatedcompanydetailsnew[0]?.cinregistrationnumber !== state.formtwo.cinRegNo ||
            companyData?.relatedcompanydetailsnew[0]?.registrationtype != state.formtwo.registrationType ||
            companyData?.relatedcompanydetailsnew[0]?.comppercentage != state.formtwo.CompositionRates ||
            companyData?.relatedcompanydetailsnew[0]?.gstrperiod !== state.formtwo.gstReturnPeriod ||
            companyData?.relatedcompanydetailsnew[0]?.lut !== state.formtwo.lutBondNo ||
            companyData?.relatedcompanydetailsnew[0]?.lutbondvalidfrom !== validFromLUT ||
            companyData?.relatedcompanydetailsnew[0]?.ewaybillflag != state.formtwo.eWayBill ||
            companyData?.relatedcompanydetailsnew[0]?.msmetype !== state.formtwo.msmeType ||
            companyData?.relatedcompanydetailsnew[0]?.udhyamregno !== state.formtwo.udhyamRegNo ||
            companyData?.relatedcompanydetailsnew[0]?.ewaybillstartdate != state.formtwo.ewayBillStartDate ||
            companyData?.relatedcompanydetailsnew[0]?.minamountewayinter != state.formtwo.eWayBillInterStateAmount ||
            companyData?.relatedcompanydetailsnew[0]?.minamountewayintra != state.formtwo.eWayBillIntraStateAmount ||
            companyData?.relatedcompanydetailsnew[0]?.einvoiceflag != state.formtwo.eInvoicing ||
            companyData?.relatedcompanydetailsnew[0]?.einvoicestartingdate != state.formtwo.eInvoiceStartDate ||
            companyData?.relatedcompanydetailsnew[0]?.gstcompensationcessflag != state.formtwo.gstCessFlag ||
            companyData?.relatedcompanydetailsnew[0]?.tradelicensenumber != state.formtwo.tradeLicenseNo ||
            companyData?.relatedcompanydetailsnew[0]?.tradelicensestartdate !== tradeValidFrom ||
            companyData?.relatedcompanydetailsnew[0]?.tradelicenseenddate != tradeValidTo ||
            companyData?.relatedcompanydetailsnew[0]?.cinregistrationdate !== validCin ||
            companyData?.relatedcompanydetailsnew[0]?.ewaybillconnect !== state.formtwo.ewayconnect
          ) {
            mainapicheck = true;
            const compRes = await addCompanyData(companyFormData);
            const regular = JSON.parse(JSON.stringify(regularSetting));
            let checkBool = false;
            if (
              companyData?.relatedcompanydetailsnew[0]?.einvoiceflag != state.formtwo.eInvoicing ||
              companyData?.relatedcompanydetailsnew[0]?.ewaybillflag != state.formtwo.eWayBill
            ) {
              if (state.formtwo.eInvoicing === 1) {
                regular.einvoicedetails = 1;
              } else {
                regular.einvoicedetails = 0;
              }
              if (state.formtwo.eWayBill) {
                regular.ewaybilldetails = 1;
              } else {
                regular.ewaybilldetails = 0;
              }
            }
            if (checkBool === false) {
              settingsRef.current?.settingFn({ regular });
            }
          }
          dispatch(gst());
          if (apiDocCheck || apiEinvCheck || entityCheck || mainapicheck || apiEwayCheck || apiDocCheck2) {
            await dispatch(fetchCompany());
            showSuccessSnackbar('Changes saved successfully');
            if (snapshotTaken) {
              setInitialStateSnapshot(JSON.parse(JSON.stringify(state)));
            }
          } else if (upper === false) {
            showSuccessSnackbar('No changes made');
          }
          setActiveStep(2);
          setDocuments(attachments);
          dispatch(setNavigationBlocked(false));
        } catch (error) {
          const err = error?.response?.data?.message || error?.response?.data?.details?.[0]?.ErrorMessage;
          if (err) {
            showWarningSnackbar(' Please provide Valid username and password');
          } else {
            showWarningSnackbar('Something went wrong');
          }
          return;
        } finally {
          setBackdropOpen(false);
        }
      } else {
        let obj = { ...state.formtwo.errorFields }; // Copy formtwo errorFields
        const formOneErrors = state.formtwo.errorFields;

        for (let key in formOneErrors) {
          if (formOneErrors[key] !== '') {
            obj[key] = formOneErrors[key]; // Add formone errors to obj
          }
        }

        const trueKeys = Object.keys(state.formtwo.errorStatus).filter((k) => state.formtwo.errorStatus[k] === true);
        const labels = trueKeys.map(humanizeKey);
        console.log(labels, 'labels');
        formTwoFocus();
        showWarningSnackbar('Please fill ' + labels.map((g) => ' ' + g));
      }
      setUpdatePassword(false);
      setEwayUpdatePassword(false);
    } else {
      if (step === 3) {
        setActiveStep(0);
        navigate('/?active=Business_Overview');
      }
    }
  };
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/CompanyDocuments/`;
  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedTypes = [
      'application/msword',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'image/jpeg',
      'image/jpg',
      'image/png',
    ];

    let allFilesValid = true;

    // Validate file types
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedTypes.includes(file.type)) {
        showWarningSnackbar('This format is not allowed');
        allFilesValid = false;
        break;
      }
    }
    if (allFilesValid === true) {
      setAttachments((currentAttachments) => {
        if (files.length + attachments.length > 6) {
          showWarningSnackbar('You cannot add more than 6 attachments');
          return currentAttachments;
        } else {
          const newAttachments = Array.from(files).map((file) => ({
            id: currentAttachments.id ? currentAttachments.id : Date.now() + file.name,
            imagename: currentAttachments.imagename ? currentAttachments.imagename : path + Date.now() + file.name,
            documentname: file.name,
            // expiredtimestamp: 0,
            type: currentAttachments.type ? currentAttachments.type : file.type,
            imageurl: currentAttachments.imageurl ? currentAttachments.imageurl : URL.createObjectURL(file),
            file,
          }));

          const filteredNewAttachments = newAttachments.filter(
            (newAttachment) => !currentAttachments.some((attachment) => attachment.documentname === newAttachment.documentname)
          );

          // console.log(filteredNewAttachments, "filteredNewAttachments");
          return [...currentAttachments, ...filteredNewAttachments];
        }
      });
    } else {
      event.target.value = ''; // Reset file input if invalid files
    }
  };

  const handleLogoChange = (event) => {
    setCompanyLogo(initialLogo);
    const files = event.target.files;
    if (files) {
      setCompanyLogo({
        LogoName: path + Date.now() + files[0].name,
        Type: files[0].type,
        LOGOURL: URL.createObjectURL(files[0]),
        file: files[0],
      });
    } else {
      setCompanyLogo({
        LogoName: '',
        Type: '',
        LOGOURL: '',
        file: '',
      });
    }
  };
  const updateAttachmentName = (id, newName) => {
    setAttachments(attachments.map((attachment) => (attachment.id === id ? { ...attachment, documentname: newName } : attachment)));
  };

  const partyTransactionApicall = async () => {
    try {
      const docs = await API.graphql(
        graphqlOperation(getCompanyV2, {
          DocumentType: 'Company',
          PartyID: 0,
          StartDate: userPreferece.financialYear?.startdate,
          EndDate: userPreferece.financialYear?.enddate,
        })
      );

      setPartyBool(docs.data?.count[0]?.transactioncount > 0);
      setSettingsBool(docs.data?.count[0]?.transactioncount > 0);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (location.pathname === '/companysetup') {
      if (activeStep !== 0) {
        setActiveStep(0);
        setEditableValue('');
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    // Only execute the logic after initial loading is complete
    // if (!initialLoadingComplete) return;
    setPartyBool(true);
    setHideFloatBtn(false);

    if (saveSkipStatus === false && activeStep < 2) {
      setEditMode(true);
      setPartyBool(false);
      if (activeStep === 0 && companyDetails?.relatedaddressentity[0]?.pincode) {
        // formOneFocus();

        showSuccessSnackbar('Please verify and save "Step 1: Company Profile"', '', '', '  ');
      }
      if (activeStep === 1 && state.formtwo.gstin !== '' && state.formtwo.registrationType != 1) {
        formTwoFocus();
        showSuccessSnackbar('Please verify and save "Step 2: Tax, GST Settings"', '', '', '  ');
      }

      if (activeStep === 0 && !companyDetails?.relatedaddressentity[0]?.pincode && !companyDetails?.relatedaddressentity[0]?.district) {
        formOneFocus();
        showWarningSnackbar('Please complete and save "Step 1: Company Profile"', '', '', '  ');
      } else if (activeStep === 1 && state.formtwo.registrationType != 1 && state.formtwo.gstin === '') {
        formTwoFocus();
        showWarningSnackbar('Please complete and save "Step 2: Tax, GST Settings"', '', '', '  ');
      }
    }

    if (activeStep === 2) {
      setEditMode(true);
    }

    if (saveSkipStatus === true && activeStep < 2) {
      setEditMode(false);
    }
    setTimeout(() => {
      if (cityref.current) {
        cityref.current.focus();
      }
    }, 0);
  }, [activeStep]);

  const ids = ['AddTypeAccountModal'];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);

  useSaveShortcut((event) => {
    if (activeStep === 0 && !anyElementExists() && editMode === true) {
      handleSteps(event, 1, false);
    } else if (activeStep === 1 && !anyElementExists() && editMode === true) {
      handleSteps(event, 2, false);
    }
  });
  const minLutValid = new Date(userPreferece?.financialYear?.startdate * 1000);
  const maxLutValid = new Date(userPreferece?.financialYear?.enddate * 1000);
  return (
    <Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>{' '}
      <Box className="stepContainer">
        <Grid
          container
          sx={{
            boxShadow: '3px 4px 11px 1px rgba(0, 0, 0, 0.25)',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '12px',
          }}
        >
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Box
              sx={stepItemStyle(0)}
              onClick={(event) => {
                if (editMode === false || activeStep === 2) {
                  handleSteps(event, 0, true);
                  setActiveStep(0);
                } else if (editMode === true && hasUnsavedChanges) {
                  showWarningSnackbar('Please save changes');
                } else {
                  setActiveStep(0);
                }
              }}
            >
              <Typography sx={{ color: activeStep === 0 ? 'white' : 'input.font' }}>Step 1: Company Profile</Typography>
              <Box sx={stepRightTriangle(0)}></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Box
              sx={stepItemStyle(1)}
              onClick={(event) => {
                if ((editMode === false && saveSkipStatus === true) || activeStep === 2) {
                  handleSteps(event, 1, true);
                } else if (editMode === true && hasUnsavedChanges) {
                  showWarningSnackbar('Please save changes');
                } else if (editMode === true && saveSkipStatus === true) {
                  setActiveStep(1);
                } else {
                  showWarningSnackbar('Please save and continue');
                }
              }}
            >
              <Typography sx={{ color: activeStep === 1 ? 'white' : 'input.font' }}>Step 2: Tax,GST Settings</Typography>
              <Box sx={stepRightTriangle(1)}></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4} alignItems="center">
            <Box
              sx={stepItemStyle(2)}
              onClick={(event) => {
                if (editMode === false) {
                  if (
                    (state.formtwo.registrationType == 2 || state.formtwo.registrationType == 3 || state.formtwo.registrationType == 4) &&
                    state.formtwo.gstin == ''
                  ) {
                    showWarningSnackbar('Please Provide GSTIN');
                    handleSteps(event, 1, true);
                  }
                  if (activeStep !== 2 && state.formone.states !== '' && state.formone.district !== '') {
                    handleSteps(event, 2, true);
                  } else if (state.formone.states == '') {
                    updateState('formone', 'states', '', true, 'State is Required');
                  } else if (state.formone.district == '') {
                    updateState('formone', 'district', '', true, 'District is Required');
                  } else if (state.formone.states == '' && state.formone.district == '') {
                    updateState('formone', 'states', '', true, 'State is Required');
                    updateState('formone', 'district', '', true, 'District is Required');
                  }
                } else if (hasUnsavedChanges) {
                  showWarningSnackbar('Please save changes');
                } else if (editMode === true && saveSkipStatus === true) {
                  setActiveStep(2);
                } else {
                  showWarningSnackbar('Please save and continue');
                }
              }}
            >
              <Typography sx={{ color: activeStep === 2 ? 'white' : 'input.font' }}>Step 3: Advanced Settings</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          flex: 8,
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '100%',
            borderRadius: '12px',
            position: 'relative',
            margin: '0 auto',
            transition: 'ease-in-out .4s',
            backgroundColor: 'bodyGray.main',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              height: '100%',
              width: '100%',
              display: 'flex',
              flexWrap: 'wrap',
              transition: 'ease-in-out .5s',
            }}
          >
            {/* form 1 */}
            {activeStep == 0 && (
              <Box
                id="Box01"
                className={'custom-scrollbar'}
                sx={{
                  padding: {
                    xs: '10px 10px',
                    sm: '20px 20px',
                    md: '50px 50px',
                  },
                  width: '100%',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  boxSizing: 'border-box',
                }}
              >
                <Grid container spacing={3} sx={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <InputField
                      name="legalName"
                      placeholder="Business Legal Name"
                      size="small"
                      inputRef={legalref}
                      autoFocus={true}
                      required={true}
                      type="text"
                      disable={editMode === false}
                      state={state.formone}
                      value={state.formone.legalName}
                      onChange={(e) => handleChange(e, 'formone', /^[a-zA-Z0-9.&' @_",()/-]*$/)}
                      onKeyDown={(e) => handleKeyDown(e, shortref)}
                      onBlur={(e) => {
                        if (!state.formone.shortName) {
                          setState((prev) => ({
                            ...prev,
                            formone: {
                              ...prev.formone,
                              shortName: e.target.value,
                              errorStatus: {
                                ...prev.formone.errorStatus,
                                shortName: true,
                              },
                              errorFields: {
                                ...prev.formone.errorFields,
                                shortName: 'Business Brand Name / Short Name is required',
                              },
                            },
                          }));
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <InputField
                      name="shortName"
                      placeholder="Business Brand Name / Short Name"
                      size="small"
                      type="text"
                      disable={editMode === false}
                      inputRef={shortref}
                      required={true}
                      state={state.formone}
                      value={state.formone.shortName}
                      onChange={(e) => handleChange(e, 'formone', /^[a-zA-Z0-9.&' @_",()/-]*$/)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <InputField
                      name="companyEmail"
                      placeholder="Communication Email"
                      size="small"
                      type="text"
                      disable={editMode === false}
                      inputRef={mailref}
                      required={true}
                      state={state.formone}
                      value={state.formone.companyEmail}
                      onChange={(e) =>
                        handleChange(
                          e,
                          'formone',
                          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Box>
                      <MuiTelInput
                        defaultCountry="IN"
                        name="mobile"
                        label="Mobile"
                        disabled={editMode === false}
                        id="mobile"
                        inputRef={mobileref}
                        fullWidth
                        size="small"
                        required={true}
                        onChange={(value) => handleMobileChange(value)}
                        value={state?.formone?.mobile}
                        error={state?.formone?.errorStatus?.mobile}
                        focusOnSelectCountry={true}
                        forceCallingCode={true}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: 'bottom', // Aligns the dropdown vertically at the bottom of the input
                            horizontal: 'left', // Aligns the dropdown horizontally to the left of the input
                          },
                          transformOrigin: {
                            vertical: 'top', // Aligns the top of the dropdown with the bottom of the input
                            horizontal: 'left', // Aligns the left of the dropdown with the left of the input
                          },
                          PaperProps: {
                            className: 'custom-scrollbar',
                            sx: {
                              borderRadius: '8px', // Rounded corners
                              boxShadow: '0 3px 6px rgba(0,0,0,0.1)', // Shadow effect
                              height: '350px',
                            },
                          },
                        }}
                        sx={{
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontSize: '20px',
                            fontWeight: 'bold',
                          },
                        }}
                      />
                      <Typography
                        sx={{
                          marginTop: '2px',
                          marginLeft: '10px',
                          marginBottom: '0px',
                          fontSize: '11px',
                          color: 'danger.main',
                        }}
                      >
                        {state.formone?.errorFields.mobile}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <InputField
                      name="website"
                      placeholder="Website Link"
                      size="small"
                      type="text"
                      disable={editMode === false}
                      inputRef={webref}
                      state={state.formone}
                      value={state.formone.website}
                      onChange={(e) => handleChange(e, 'formone', /^(https?:\/\/)?(www\.)?([\da-z\.-]+)\.([a-z\.]{2,})([\/\w \.-]*)*\/?$/)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <TextField
                      error={state.formone.errorStatus.currency === true ? true : false}
                      select
                      id="Currency"
                      name="currency"
                      disable={editMode === false}
                      label="Currency"
                      required={true}
                      variant="outlined"
                      disabled={true}
                      size="small"
                      defaultValue={'1'}
                      fullWidth
                      value={state.formone.currency}
                      onChange={(e) => {
                        const name = e.target.name;
                        const value = e.target.value;
                        if (value != 'addCurrency') {
                          if (value === '') {
                            setState((prev) => ({
                              ...prev,
                              ['formone']: {
                                ...prev['formone'],
                                [name]: value,
                                ['errorStatus']: {
                                  ...prev['formone'].errorStatus,
                                  [name]: true,
                                },
                                ['errorFields']: {
                                  ...prev['formone'].errorFields,
                                  [name]: name + ' is required',
                                },
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              ['formone']: {
                                ...prev['formone'],
                                [name]: value,
                                ['errorStatus']: {
                                  ...prev['formone'].errorStatus,
                                  [name]: false,
                                },
                                ['errorFields']: {
                                  ...prev['formone'].errorFields,
                                  [name]: '',
                                },
                              },
                            }));
                          }
                        }
                      }}
                      sx={{
                        '.MuiFormLabel-asterisk': {
                          color: 'danger.main',
                          fontSize: '20px',
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      {[
                        { option: 'Rupee (₹)', value: '1' },
                        { option: 'Dollar ($)', value: '2' },
                        { option: 'Euro (€)', value: '3' },
                      ].map((item, ind) => {
                        return (
                          <MenuItem key={item.value} value={`${item.value}`}>
                            <ListItemText sx={{ margin: '0px' }} primary={item.option} />
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <Typography
                      sx={{
                        marginTop: '2px',
                        marginLeft: '10px',
                        marginBottom: '0px',
                        fontSize: '11px',
                        color: 'danger.main',
                      }}
                    >
                      {state.formone?.errorFields.currency}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <FormControl sx={{ width: '100%' }}>
                      <Autocomplete
                        id="businessTypes"
                        multiple
                        limitTags={2}
                        size="small"
                        disabled={editMode === false}
                        options={businessTypes.map((type) => type.businesstype)}
                        ListboxProps={{
                          style: {
                            maxHeight: '200px',
                            overflow: 'auto',
                            paddingBottom: '8px',
                          },
                        }}
                        onChange={(event, newValue) => {
                          if (newValue.length === 0) {
                            // Clear icon triggered
                            console.log('Cleared all values');

                            setState((prev) => ({
                              ...prev,
                              formone: {
                                ...prev.formone,
                                buisnessType: [],
                              },
                            }));
                          }
                        }}
                        value={
                          Array.isArray(state?.formone.buisnessType)
                            ? state?.formone?.buisnessType.filter((type) =>
                                businessTypes.some((business) => business?.businesstype === type)
                              )
                            : []
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Business Type"
                            variant="outlined"
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          />
                        )}
                        renderTags={(value, getTagProps) => (
                          <>
                            {state.formone.buisnessType.slice(0, 2).map((option, index) => (
                              <Chip
                                key={index + 1}
                                label={option}
                                {...getTagProps({ index })}
                                onDelete={() => {
                                  // Remove the clicked chip from state
                                  setState((prev) => ({
                                    ...prev,
                                    formone: {
                                      ...prev.formone,
                                      buisnessType: prev.formone.buisnessType.filter((item) => item !== option),
                                    },
                                  }));
                                }}
                                style={{ maxWidth: '38%' }}
                                sx={{
                                  maxWidth: '50px',
                                  textOverflow: 'ellipsis',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  fontSize: '11px',
                                  height: '25px',
                                  p: 0,
                                  '& .MuiChip-deleteIcon': {
                                    fontSize: '15px',
                                    p: 0,
                                  },
                                }}
                              />
                            ))}
                            {state.formone.buisnessType.length > 2 && (
                              <Tooltip
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: '#424242', // Set your desired background color here
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: '#424242', // Match arrow color with the background of the tooltip
                                    },
                                  },
                                }}
                                title={
                                  <List
                                    className="custom-scrollbar"
                                    sx={{
                                      padding: 1,
                                      overflowY: 'scroll',
                                      maxHeight: `${document.getElementById('businessTypes')?.getBoundingClientRect().bottom - 110}px`,
                                      '&::-webkit-scrollbar-track': {
                                        background: '#424242',
                                      },
                                      '&::-webkit-scrollbar-thumb': {
                                        border: '3px solid',
                                        borderColor: '#424242',
                                      },
                                    }}
                                  >
                                    {state?.formone?.buisnessType
                                      .filter((type) => businessTypes.some((business) => business?.businesstype === type))
                                      .slice(2)
                                      .map((item, index) => (
                                        <ListItem key={index} sx={{ padding: '4px 8px' }}>
                                          {item}
                                        </ListItem>
                                      ))}
                                  </List>
                                }
                                arrow
                              >
                                <Chip
                                  key={state.formone.buisnessType.length + 1}
                                  label={`+${value.length - 2}`}
                                  // {...getTagProps({ index: value.length })}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                  }}
                                  sx={{
                                    height: '25px',
                                    cursor: 'default',
                                    pointerEvents: 'none',
                                    whiteSpace: 'pre-wrap',
                                  }}
                                />
                              </Tooltip>
                            )}
                          </>
                        )}
                        renderOption={(props, option, { selected }) => {
                          if (option === 'Add Business Type') {
                            return (
                              <Box
                                sx={{
                                  boxShadow: '0px -4px 10px -2px rgba(0, 0, 0, 0.2)',
                                  width: '100%',
                                  position: 'fixed',
                                  bottom: '-20px',
                                  zIndex: '1000',
                                  background: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                }}
                              >
                                <MenuItem
                                  sx={{ whiteSpace: 'nowrap', m: 0 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setBusinessorIndustryType('BusinessType');
                                    setOpenBusinessIndustryTypeMdal(true);
                                  }}
                                >
                                  <Settings fontSize="small" sx={{ marginRight: '5px' }} />
                                  <ListItemText primary={' Add Business Type'} />
                                </MenuItem>
                              </Box>
                            );
                          } else {
                            return (
                              <MenuItem
                                key={option}
                                value={option}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                                onClick={() => {
                                  if (!option.includes('Add Business Type')) {
                                    setState((prev) => ({
                                      ...prev,
                                      formone: {
                                        ...prev.formone,
                                        buisnessType: prev.formone.buisnessType.includes(option)
                                          ? prev.formone.buisnessType.filter((item) => item !== option) // Remove the option
                                          : [...prev.formone.buisnessType, option],
                                      },
                                    }));
                                  }
                                }}
                              >
                                <Checkbox disableRipple={false} checked={selected} />
                                <ListItemText primary={option} />
                              </MenuItem>
                            );
                          }
                        }}
                        getOptionLabel={(option) => option}
                      />
                    </FormControl>
                  </Grid>
                  {console.log(businessTypes, 'businessTypes')}
                  {console.log(state.formone, 'formone')}
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <FormControl
                      sx={{
                        width: '100%',
                      }}
                    >
                      <Autocomplete
                        id="industryTypes"
                        multiple
                        limitTags={2}
                        size="small"
                        disabled={editMode === false}
                        options={industryTypes.map((name) => name.industrytype)}
                        value={
                          Array.isArray(state?.formone.industryType)
                            ? state?.formone?.industryType.filter((type) =>
                                industryTypes.some((business) => business?.industrytype === type)
                              )
                            : []
                        }
                        ListboxProps={{
                          style: {
                            maxHeight: '200px',
                            overflow: 'auto',
                            paddingBottom: '8px',
                          },
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            const element = document.getElementById('uploadlogo');
                            if (element) {
                              element.focus();
                              e.preventDefault();
                              e.stopPropagation();
                            }
                          }
                        }}
                        onChange={(event, newValue) => {
                          if (newValue.length === 0) {
                            setState((prev) => ({
                              ...prev,
                              formone: {
                                ...prev.formone,
                                industryType: [],
                              },
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              textOverflow: 'ellipsis', // Ensures text within the input field does not overflow
                              whiteSpace: 'nowrap',
                            }}
                            label="Industry Type"
                            variant="outlined"
                          />
                        )}
                        renderTags={(value, getTagProps) => (
                          <>
                            {state.formone.industryType.slice(0, 2).map((option, index) => (
                              <Chip
                                key={index + 1}
                                label={option}
                                {...getTagProps({ index })}
                                style={{ maxWidth: '38%' }}
                                onDelete={() => {
                                  // Remove the clicked chip from state
                                  setState((prev) => ({
                                    ...prev,
                                    formone: {
                                      ...prev.formone,
                                      industryType: prev.formone.industryType.filter((item) => item !== option),
                                    },
                                  }));
                                }}
                                sx={{
                                  maxWidth: '50px',
                                  textOverflow: 'ellipsis',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  fontSize: '11px', // Font size for the chip text
                                  height: '25px', // Height of the chip
                                  p: 0, // Padding within the chip
                                  '& .MuiChip-deleteIcon': {
                                    fontSize: '15px', // Font size for the delete icon
                                    p: 0, // Padding for the delete icon
                                  },
                                }}
                              />
                            ))}
                            {state.formone.industryType.length > 2 && (
                              <Tooltip
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: '#424242', // Set your desired background color here
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: '#424242', // Match arrow color with the background of the tooltip
                                    },
                                  },
                                }}
                                title={
                                  <List
                                    className="custom-scrollbar"
                                    sx={{
                                      padding: 1,
                                      overflowY: 'scroll',
                                      maxHeight: `${document.getElementById('industryTypes')?.getBoundingClientRect().bottom - 110}px`,
                                      '&::-webkit-scrollbar-track': {
                                        background: '#424242',
                                      },
                                      '&::-webkit-scrollbar-thumb': {
                                        border: '3px solid',
                                        borderColor: '#424242',
                                      },
                                    }}
                                  >
                                    {state?.formone?.industryType
                                      .filter((type) => industryTypes.some((business) => business?.industrytype === type))
                                      .slice(2)
                                      .map((item, index) => (
                                        <ListItem key={index} sx={{ padding: '4px 8px' }}>
                                          {item}
                                        </ListItem>
                                      ))}
                                  </List>
                                }
                                arrow
                              >
                                <Chip
                                  key={state.formone.industryType.length + 2}
                                  label={`+${state.formone.industryType.length - 2}`}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    console.log('kkkkkkkkkkk');
                                  }}
                                  sx={{
                                    height: '25px',
                                    cursor: 'default',
                                    pointerEvents: 'none',
                                    whiteSpace: 'pre-wrap',
                                  }}
                                />
                              </Tooltip>
                            )}
                          </>
                        )}
                        renderOption={(props, option, { selected }) => {
                          if (option === 'Add Industry Type') {
                            return (
                              <Box
                                sx={{
                                  boxShadow: '0px -4px 10px -2px rgba(0, 0, 0, 0.2)',
                                  width: '100%',
                                  position: 'fixed',
                                  bottom: '-20px',
                                  zIndex: '1000',
                                  background: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                }}
                              >
                                <MenuItem
                                  sx={{ whiteSpace: 'nowrap', m: 0 }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setBusinessorIndustryType('IndustryType');
                                    setOpenBusinessIndustryTypeMdal(true);
                                  }}
                                >
                                  <Settings fontSize="small" sx={{ marginRight: '5px' }} />
                                  <ListItemText primary={' Add Industry Type'} />
                                </MenuItem>
                              </Box>
                            );
                          } else {
                            return (
                              <MenuItem
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                                onClick={() => {
                                  if (!option.includes('Add Industry Type')) {
                                    setState((prev) => ({
                                      ...prev,
                                      formone: {
                                        ...prev.formone,
                                        industryType: prev.formone.industryType.includes(option)
                                          ? prev.formone.industryType.filter((item) => item !== option) // Remove the option
                                          : [...prev.formone.industryType, option],
                                      },
                                    }));
                                  }
                                }}
                              >
                                <Checkbox disableRipple={false} checked={selected} />
                                <ListItemText primary={option} />
                              </MenuItem>
                            );
                          }
                        }}
                        getOptionLabel={(option) => option}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) => option === value}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    {companyLogo.LOGOURL === '' ? (
                      <>
                        <input
                          ref={logoRef}
                          type="file"
                          onChange={handleLogoChange}
                          multiple
                          style={{ display: 'none' }}
                          accept="
                    image/jpeg,
                    image/jpg,
                    image/png
                  "
                        />
                        <Button
                          disableRipple={false}
                          onClick={() => logoRef?.current?.click()}
                          size="small"
                          variant="outlined"
                          disabled={editMode === false}
                          id="uploadlogo"
                          sx={{
                            fontSize: '12px',
                            color: 'input.font',
                            marginBottom: '5px',
                            boxShadow: 'none',
                            marginTop: '-3px',
                          }}
                        >
                          Upload Company Logo
                        </Button>
                      </>
                    ) : null}

                    {companyLogo.LOGOURL !== '' ? (
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Box
                          sx={{
                            textTransform: 'none',
                            width: '100%',
                            border: '1px dashed',
                            borderColor: 'input.border',
                            position: 'relative',
                            color: 'input.font',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '5px 0px',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '0.75em',
                              letterSpacing: '0.00938em',
                              position: 'absolute',
                              top: '-10px',
                              left: '9px',
                              background: '#fff',
                              padding: '0px 3px',
                              color: 'input.label',
                            }}
                          >
                            Uploaded Logo
                          </Typography>
                          <img
                            src={companyLogo?.LOGOURL}
                            style={{
                              width: '100px',
                              height: '70px',
                            }}
                          />
                        </Box>

                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Button
                            variant="contained"
                            component="label"
                            disabled={editMode === false}
                            sx={{ marginTop: '10px', fontSize: '13px' }}
                          >
                            Replace
                            <input hidden accept="image/*" onChange={(event) => handleLogoChange(event)} type="file" />
                          </Button>

                          <Button
                            disableRipple={false}
                            disabled={editMode === false}
                            variant="outlined"
                            component="label"
                            sx={{ marginTop: '10px', fontSize: '13px' }}
                            onClick={() => {
                              setCompanyLogo(initialLogo);
                            }}
                          >
                            Remove
                          </Button>
                        </Box>
                      </Box>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '10px',
                    }}
                  >
                    <Typography
                      sx={{
                        marginRight: '10px',
                        fontWeight: '600',
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                      }}
                      variant="h6"
                    >
                      Address Info
                    </Typography>
                    <Box
                      sx={{
                        flexGrow: 1,
                        borderBottom: '1px solid',
                        borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#ffff' : '',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Country name="Country" size="small" label="Country" value={state.formone.country} disabled={true} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Pincode
                      name="pincode"
                      id="pincode"
                      size="small"
                      error={state.formone.errorStatus.pincode}
                      errormsg={state.formone.errorFields.pincode}
                      placeholder="Pincode"
                      inputRef={pincoderef}
                      disable={editMode === false}
                      value={state.formone.pincode}
                      required={true}
                      onChange={handlePincodeChange}
                      onKeyDown={handlePincodeKeyDown}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <State
                      ref={stateref}
                      name="states"
                      size="small"
                      label="State"
                      value={state.formone.states}
                      disabled={editMode === false}
                      required={true}
                      setDistrictList={setDistrictList}
                      setStateList={setStateList}
                      onStateChange={handleStateChange}
                      error={state.formone.errorStatus.states}
                      errormessage={state.formone.errorFields.states}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <City
                      name="city"
                      size="small"
                      disabled={editMode === false}
                      value={state.formone.city}
                      options={options}
                      required={true}
                      onChange={handleCityChange}
                      inputRef={cityref}
                      error={state.formone.errorStatus.city}
                      errormsg={state?.formone?.errorFields?.city}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={4}
                    onKeyDown={(e) => {
                      if (e.key == 'Enter') {
                        if (document.getElementById('buisnessAddress')) {
                          document.getElementById('buisnessAddress').focus();
                        }
                      }
                    }}
                  >
                    <District
                      name="district"
                      size="small"
                      label="District"
                      value={state.formone.district}
                      disabled={editMode === false}
                      required={true}
                      list={districtList}
                      inputRef={districtref}
                      stateVal={state.formone.states}
                      onDistrictChange={handleDistrictChange}
                      error={state.formone.errorStatus.district}
                      errormessage={state.formone.errorFields.district}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <TextField
                      id="buisnessAddress"
                      name="buisnessAddress"
                      label={
                        <Box display="flex" alignItems="center" sx={{ marginTop: '-10px' }}>
                          Business Address
                          <span
                            style={{
                              // '.MuiFormLabel-asterisk': {
                              color: '#e55353',
                              fontSize: '20px',
                              fontWeight: 700,
                              // },
                            }}
                          >
                            *
                          </span>
                          <InfoButton title="This will be displayed in invoice" placement="right-start" />
                        </Box>
                      }
                      multiline
                      // required={true}
                      size="small"
                      fullWidth
                      error={state.formone.errorStatus.buisnessAddress}
                      helperText={state.formone.errorFields.buisnessAddress}
                      disabled={editMode === false}
                      autoComplete="off"
                      rows={4}
                      InputProps={{
                        classes: {
                          input: 'custom-scrollbar', // Your custom class
                        },
                      }}
                      onChange={(e) => handleChange(e, 'formone')}
                      value={state?.formone?.buisnessAddress}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
            {/* form 2 */}
            {activeStep == 1 && (
              <Box
                id="Box02"
                className={'custom-scrollbar'}
                sx={{
                  padding: {
                    xs: '10px',
                    sm: '20px',
                    md: '30px',
                  },
                  width: '100%',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    borderRadius: '8px',
                  }}
                >
                  <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
                    <Grid item xs={12} sm={5.5}>
                      <Box
                        id="TaxRadio"
                        sx={{
                          position: 'relative',
                          border: 'solid 1px',
                          borderColor: state?.formtwo?.errorStatus?.registrationType === true ? 'danger.main' : 'input.border',
                          borderRadius: '4px',
                          padding: { xs: '8px 10px', sm: '3px 10px' },
                          '&:focus-within': {
                            border: partyBool ? '' : '4px solid #ffb74d', // Background when focused
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: { xs: '0.75rem', sm: '0.60em' },
                            letterSpacing: '0.00938em',
                            position: 'absolute',
                            top: '-10px',
                            left: '9px',
                            padding: '2px',
                            background: theme?.palette?.TmId.id.toString().includes('9') ? '#000000ff' : '#fff',

                            color: state?.formtwo?.errorStatus?.registrationType === true ? 'danger.main' : 'input.font',
                          }}
                        >
                          Registration Type
                        </Typography>
                        <RadioGroup
                          sx={{
                            display: 'flex',
                            flexDirection: { xs: 'row', sm: 'row' },
                            padding: '5px 10px',
                          }}
                          id="RegistrationType"
                          name="registrationType"
                          disabled={partyBool}
                          value={state?.formtwo?.registrationType}
                          onChange={(e) => {
                            const name = e.target.name;
                            const value = e.target.value;
                            if (value === '') {
                              setState((prev) => ({
                                ...prev,
                                ['formtwo']: {
                                  ...prev['formtwo'],
                                  [name]: value,
                                  ['errorStatus']: {
                                    ...prev['formtwo'].errorStatus,
                                    [name]: true,
                                  },
                                  ['errorFields']: {
                                    ...prev['formtwo'].errorFields,
                                    [name]: 'Registration Type is required',
                                  },
                                },
                              }));
                            } else {
                              if (value == '1') {
                                setState((prev) => ({
                                  ...prev,
                                  ['formtwo']: {
                                    ...prev['formtwo'],
                                    [name]: value,
                                    CompositionRates: 0,
                                    gstApplicableDate: '',
                                    ['errorStatus']: {
                                      ...prev['formtwo'].errorStatus,
                                      [name]: false,
                                      gstin: false,
                                      pan: false,
                                      CompositionRates: false,
                                      gstApplicableDate: false,
                                    },
                                    ['errorFields']: {
                                      ...prev['formtwo'].errorFields,
                                      [name]: '',
                                      gstin: '',
                                      pan: '',
                                      CompositionRates: '',
                                      gstApplicableDate: '',
                                    },
                                  },
                                }));
                              } else if (value == '3') {
                                setState((prev) => ({
                                  ...prev,
                                  ['formtwo']: {
                                    ...prev['formtwo'],
                                    [name]: value,
                                    ['errorStatus']: {
                                      ...prev['formtwo'].errorStatus,
                                      [name]: false,
                                      CompositionRates: true,
                                    },
                                    ['errorFields']: {
                                      ...prev['formtwo'].errorFields,
                                      [name]: '',
                                      CompositionRates: 'please select GST composition rate',
                                    },
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  ['formtwo']: {
                                    ...prev['formtwo'],
                                    [name]: value,
                                    CompositionRates: 0,
                                    ['errorStatus']: {
                                      ...prev['formtwo'].errorStatus,
                                      [name]: false,
                                      CompositionRates: false,
                                    },
                                    ['errorFields']: {
                                      ...prev['formtwo'].errorFields,
                                      [name]: '',
                                      CompositionRates: '',
                                    },
                                  },
                                }));
                              }
                            }
                          }}
                        >
                          <FormControlLabel
                            value="1"
                            control={<Radio size="small" disableRipple />}
                            disabled={partyBool}
                            label="Unregistered"
                          />
                          <FormControlLabel value="2" control={<Radio size="small" />} disabled={partyBool} label="Registered" />
                          <FormControlLabel value="3" control={<Radio size="small" />} disabled={partyBool} label="Composition" />
                          <FormControlLabel value="4" disabled={partyBool} control={<Radio size="small" />} label="SEZ" />
                        </RadioGroup>
                      </Box>
                      <Typography
                        sx={{
                          marginTop: '2px',
                          marginLeft: '10px',
                          marginBottom: '0px',
                          fontSize: '11px',
                          color: 'danger.main',
                        }}
                      >
                        {state?.formtwo?.errorFields?.registrationType}
                      </Typography>
                    </Grid>
                    {state?.formtwo.registrationType != '1' && (
                      <>
                        <Grid item xs={12} sm={6} md={6} lg={3}>
                          <InputField
                            name="gstin"
                            placeholder="GSTIN"
                            size="small"
                            inputRef={gstinref}
                            required={true}
                            type="text"
                            state={state.formtwo}
                            value={state.formtwo.gstin}
                            disable={partyBool}
                            onKeyDown={(e) => {
                              if (e.key == 'Tab' && e.shiftKey) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              if (e.target.value.trim().length <= 15) {
                                handleChange(
                                  e,
                                  'formtwo',
                                  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Za-z]{1}$/,
                                  companyData?.relatedCompanyEntity?.[0]?.GSTIN
                                );
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={3}>
                          <InputField
                            name="gstReturnPeriod"
                            placeholder="GST Return Period/Interval"
                            size="small"
                            type="text"
                            state={state.formtwo}
                            value={state.formtwo.registrationType == 3 ? 'Quarterly' : 'Monthly'}
                            disable={true}
                          />
                        </Grid>
                        {state?.formtwo?.registrationType != '1' && state?.formtwo?.registrationType != '3' && (
                          <Grid item xs={12} sm={6}>
                            <CheckBoxWithLabel
                              label=" Enable GST Compensation Cess"
                              htmlFor="gstCessFlag"
                              checked={state.formtwo.gstCessFlag == 1}
                              disable={editMode === false}
                              onChange={(event) => {
                                if (companyDetails?.relatedcompanydetailsnew[0].disablegstcompensation === 0) {
                                  showWarningSnackbar('Since Transaction exists, GST Compensation Cess cannot be disabled');
                                } else {
                                  setState((prev) => ({
                                    ...prev,
                                    ['formtwo']: {
                                      ...prev['formtwo'],
                                      ['gstCessFlag']: event?.target.checked ? 1 : 0,
                                    },
                                  }));
                                }
                              }}
                            />
                          </Grid>
                        )}
                        {state?.formtwo?.registrationType == '3' && (
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <AutoCompleteMUI
                              id="CompositionRates"
                              name="CompositionRates"
                              label="Select Composition GST Rates"
                              options={compositionScheme}
                              value={state?.formtwo?.CompositionRates}
                              state={state?.formtwo}
                              disabled={editMode === false}
                              inputRef={compref}
                              required={true}
                              onBlur={() => {
                                if (!state?.formtwo?.CompositionRates) {
                                  updateState('formtwo', 'CompositionRates', '', true, 'please select GST composition rate');
                                }
                              }}
                              onChange={(event, option) => {
                                if (option?.value !== undefined) {
                                  updateState('formtwo', 'CompositionRates', option?.value, false, '');
                                } else {
                                  updateState('formtwo', 'CompositionRates', '', true, 'please select GST composition rate');
                                }
                              }}
                            />
                          </Grid>
                        )}
                      </>
                    )}
                  </Grid>
                  <Box>
                    {state?.formtwo?.registrationType != '1' && (
                      <CompanysetupEway
                        checked={state?.formtwo.eWayBill == '1'}
                        disable={editMode === false}
                        state={state}
                        ref={settingsRef}
                        setRegularSettings={setRegularSettings}
                        updatePassword={updatePassword}
                        setUpdatePassword={setUpdatePassword}
                        setEInvNotes={setEInvNotes}
                        onEwayChange={onEwayChange}
                        settingsBool={settingsBool}
                        // EinvoiceBlur={EinvoiceBlur}
                        onEinvChange={onEinvChange}
                        setEwayNotes={setEwayNotes}
                        linkRef={linkRef}
                        setEwayUpdatePassword={setEwayUpdatePassword}
                        ewayUpdatePassword={ewayUpdatePassword}
                        onEwayConnectChange={onEwayConnectChange}
                        onEinvConnectChange={onEinvConnectChange}
                        eWayBillBool={state?.formtwo.eWayBill == '1' ? true : false}
                        handleDateChange={handleDateChange}
                        companyData={companyData}
                        handleChange={handleChange}
                        usernameRef={usernameRef}
                      />
                    )}
                  </Box>
                  {state?.formtwo?.registrationType != '1' && (
                    <Grid container spacing={3} sx={{ marginBottom: '20px' }}>
                      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                          sx={{
                            marginRight: '10px',
                            fontWeight: '600',
                            color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          }}
                          variant="h6"
                        >
                          LUT Bond Details
                        </Typography>
                        <Box
                          sx={{
                            flexGrow: 1,
                            borderBottom: '1px solid',
                            borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#ffff' : '',
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={3}>
                        <InputField
                          name="lutBondNo"
                          placeholder="LUT Bond Number"
                          size="small"
                          type="text"
                          disable={editMode === false}
                          state={state.formtwo}
                          value={state?.formtwo?.lutBondNo}
                          onChange={(e) => {
                            handleChange(e, 'formtwo');
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={2.5}>
                        <MUIDatePicker
                          label="Valid From"
                          disable={state?.formtwo?.lutBondNo?.length > 0 && editMode === true ? false : true}
                          value={state?.formtwo?.lutValidFrom === '' ? '' : dayjs(state?.formtwo?.lutValidFrom)}
                          state={state?.formtwo}
                          inputRef={lutFrom}
                          required={state.formtwo.errorFields.lutValidFrom === 'Date required'}
                          minDate={minLutValid}
                          maxDate={maxLutValid}
                          name="lutValidFrom"
                          onChange={(dateValue, context) => handleDateChange(dateValue, context, 'formtwo', 'lutValidFrom')}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={2.5}>
                        <MUIDatePicker
                          label="Valid To"
                          disable={state?.formtwo?.lutValidFrom?.length > 0 && editMode === true ? false : true}
                          value={state?.formtwo?.lutValidTo === '' ? '' : dayjs(state?.formtwo?.lutValidTo)}
                          minDate={dayjs(state?.formtwo?.lutValidFrom)}
                          maxDate={maxLutValid}
                          // minDate={state?.formtwo?.lutValidFrom}
                          required={state.formtwo.errorFields.lutValidTo === 'Date required'}
                          inputRef={lutTo}
                          state={state?.formtwo}
                          name="lutValidTo"
                          onChange={(dateValue, context) => handleDateChange(dateValue, context, 'formtwo', 'lutValidTo')}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} sx={{ display: 'flex' }}>
                        <Typography
                          sx={{
                            color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          }}
                        >
                          Expires :{' '}
                        </Typography>
                        <Typography
                          sx={{
                            color:
                              state?.formtwo?.lutExpiry === 'expired'
                                ? 'red'
                                : theme.palette.TmId.id.toString().includes('9')
                                ? 'white'
                                : 'black',
                          }}
                        >
                          {
                            state?.formtwo?.lutValidFrom &&
                              state?.formtwo?.lutValidTo &&
                              (state?.formtwo?.lutExpiry === 1 ? (
                                ' ' + ` ${state?.formtwo?.lutExpiry} Day`
                              ) : state?.formtwo?.lutExpiry > 1 ? (
                                ' ' + ` ${state?.formtwo?.lutExpiry} Days`
                              ) : state?.formtwo?.lutExpiry === 0 ? (
                                <p style={{ color: 'red' }}>Expiring </p>
                              ) : state?.formtwo?.lutExpiry < 0 || state?.formtwo?.lutExpiry === 'expired' ? (
                                <p style={{ color: 'red' }}>Expired</p>
                              ) : (
                                ''
                              ))
                            // : ""
                          }{' '}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container spacing={3} sx={{ marginBottom: '20px' }}>
                    <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography
                        sx={{
                          marginRight: '10px',
                          fontWeight: '600',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                        }}
                        variant="h6"
                      >
                        Registration Details
                      </Typography>
                      <Box
                        sx={{
                          flexGrow: 1,
                          borderBottom: '1px solid',
                          borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#ffff' : '',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3}>
                      <InputField
                        id={'PAN Number'}
                        disable={editMode === false}
                        name="pan"
                        placeholder="Permanent Account Number"
                        size="small"
                        required={state.formtwo.registrationType == '1' ? false : true}
                        type="text"
                        inputRef={panref}
                        state={state.formtwo}
                        value={state.formtwo?.pan?.toUpperCase()}
                        onChange={(e) => {
                          handleChange(e, 'formtwo', /[A-Z]{5}[0-9]{4}[A-Z]{1}$/, companyData?.relatedcompanydetailsnew[0]?.pannumber);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3}>
                      <InputField
                        name="TDSTCSNumber"
                        id="TDS/TCS Number"
                        disable={editMode === false}
                        placeholder="TAN Number"
                        inputRef={tanref}
                        size="small"
                        type="text"
                        state={state.formtwo}
                        value={state?.formtwo?.TDSTCSNumber}
                        onChange={(e) =>
                          handleChange(
                            e,
                            'formtwo',
                            /^[A-Za-z]{4}[0-9]{5}[A-Za-z]$/,
                            companyData?.relatedcompanydetailsnew[0]?.tdstcsnumber
                          )
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3}>
                      <AutoCompleteMUI
                        name="entityType"
                        id="entityType"
                        label="Entity Type"
                        options={newEntityOptions}
                        disabled={editMode === false}
                        value={state?.formtwo?.entityType}
                        inputRef={entityRef}
                        required={true}
                        state={state?.formtwo}
                        onChange={(event, option) => {
                          console.log(option, 'option');

                          if (option !== null) {
                            if (option?.value !== null) {
                              updateState('formtwo', 'entityType', option?.value, false, '');
                            }
                          } else {
                            updateState('formtwo', 'entityType', '', true, 'Please select entity');
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} sx={{ marginBottom: '20px' }}>
                    <Grid item xs={12} sm={4} md={4} lg={3}>
                      <InputField
                        name="cinRegNo"
                        placeholder="CIN/LLPIN/Firm Registration Number"
                        size="small"
                        type="text"
                        disable={editMode === false}
                        state={state.formtwo}
                        minDate={minLutValid}
                        maxDate={maxLutValid}
                        value={state?.formtwo?.cinRegNo}
                        onChange={(e) => {
                          handleChange(e, 'formtwo', '', companyData?.relatedcompanydetailsnew[0]?.cinregistrationnumber);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3}>
                      <MUIDatePicker
                        label="Date of Registration"
                        disable={state?.formtwo?.cinRegNo.length > 0 && editMode === true ? false : true}
                        value={state?.formtwo?.cinRegDate !== '' ? dayjs(state?.formtwo?.cinRegDate) : ''}
                        state={state?.formtwo}
                        name="cinRegDate"
                        onChange={(dateValue, context) =>
                          handleDateChange(
                            dateValue,
                            context,
                            'formtwo',
                            'cinRegDate',
                            companyData?.relatedcompanydetailsnew[0]?.cinregistrationdate
                          )
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} sx={{ marginBottom: '20px' }}>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                      <InputField
                        name="tradeLicenseNo"
                        placeholder="Trade License Number"
                        size="small"
                        disable={editMode === false}
                        type="text"
                        state={state.formtwo}
                        value={state?.formtwo?.tradeLicenseNo}
                        onChange={(e) => {
                          handleChange(e, 'formtwo', '', companyData?.relatedcompanydetailsnew[0]?.tradelicensenumber);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                      <MUIDatePicker
                        label="Valid From"
                        disable={state?.formtwo?.tradeLicenseNo.length > 0 && editMode === true ? false : true}
                        value={state?.formtwo?.tradeLicNoFromDate === '' ? '' : dayjs(state?.formtwo?.tradeLicNoFromDate)}
                        state={state?.formtwo}
                        name="tradeLicNoFromDate"
                        minDate={minLutValid}
                        inputRef={tradeFrom}
                        required={state.formtwo.errorFields.tradeLicNoFromDate === 'Date required'}
                        maxDate={maxLutValid}
                        onChange={(dateValue, context) => handleDateChange(dateValue, context, 'formtwo', 'tradeLicNoFromDate')}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                      <MUIDatePicker
                        label="Valid To"
                        disable={state?.formtwo?.tradeLicNoFromDate?.length > 0 && editMode === true ? false : true}
                        value={state?.formtwo?.tradeLicNoToDate === '' ? '' : dayjs(state?.formtwo?.tradeLicNoToDate)}
                        minDate={dayjs(state?.formtwo?.tradeLicNoFromDate)}
                        maxDate={maxLutValid}
                        state={state?.formtwo}
                        inputRef={tradeTo}
                        required={state.formtwo.errorFields.tradeLicNoToDate === 'Date required'}
                        name="tradeLicNoToDate"
                        onChange={(dateValue, context) => handleDateChange(dateValue, context, 'formtwo', 'tradeLicNoToDate')}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3} sx={{ display: 'flex' }}>
                      <Typography
                        sx={{
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                        }}
                      >
                        Expires :{' '}
                      </Typography>
                      <Typography>
                        {state?.formtwo?.tradeLicNoFromDate !== '' &&
                          state?.formtwo?.tradeLicNoToDate !== '' &&
                          (state?.formtwo?.expiresin === 1 ? (
                            ' ' + ` ${state?.formtwo?.expiresin} Day`
                          ) : state?.formtwo?.expiresin > 1 ? (
                            ' ' + ` ${state?.formtwo?.expiresin} Days`
                          ) : state?.formtwo?.expiresin === 0 ? (
                            <p style={{ color: 'red' }}>Expiring </p>
                          ) : state?.formtwo?.expiresin < 0 || state?.formtwo?.expiresin === 'expired' ? (
                            <p style={{ color: 'red' }}>Expired</p>
                          ) : (
                            ''
                          ))}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={3}>
                      <AutoCompleteMUI
                        name="msmeType"
                        label="MSME Type If Applicable"
                        disabled={editMode === false}
                        options={[
                          { option: 'Micro', value: 'Micro' },
                          { option: 'Small', value: 'Small' },
                          { option: 'Medium', value: 'Medium' },
                        ]}
                        value={state?.formtwo?.msmeType || null}
                        state={state?.formtwo}
                        onChange={(event, option) => {
                          if (option !== null) {
                            if (option?.value !== null) {
                              updateState('formtwo', 'msmeType', option?.value, false, '');
                            }
                          } else {
                            updateState('formtwo', 'msmeType', '', false, '');
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3.5}>
                      <InputField
                        id={'udhyamRegNo'}
                        name="udhyamRegNo"
                        placeholder="Udyam Registration Number If Applicable"
                        size="small"
                        disable={editMode === false}
                        type="text"
                        state={state.formtwo}
                        value={state.formtwo?.udhyamRegNo}
                        onChange={(e) => handleChange(e, 'formtwo', '', companyData?.relatedcompanydetailsnew[0]?.udhyamregno)}
                      />
                    </Grid>

                    <Grid item container xs={12} sx={{ display: { xs: 'block', lg: 'flex' } }}>
                      <Grid sx={{ display: 'flex' }} item lg={4}>
                        <Box>
                          <Typography
                            sx={{
                              marginRight: '10px',
                              fontWeight: 'bold',
                              marginBottom: '5px',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                            variant="h2"
                          >
                            Documents
                          </Typography>
                        </Box>
                        <Box>
                          <input
                            ref={imageRef}
                            type="file"
                            id="fileInput"
                            onChange={handleFileChange}
                            multiple
                            style={{ display: 'none' }}
                            accept="
                    application/msword,
                    application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.ms-excel,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/vnd.ms-powerpoint,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    image/jpeg,
                    image/jpg,
                    image/png
                  "
                          />
                          <Button
                            // id="DocBtn"
                            onClick={() => imageRef?.current?.click()}
                            size="small"
                            variant="contained"
                            sx={{
                              fontSize: '12px',
                              padding: '5px 7px',
                              marginBottom: '5px',
                              boxShadow: 'none',
                              marginTop: '-3px',
                            }}
                            disabled={editMode === false}
                          >
                            <AddIcon fontSize="15px" />
                            {' ADD DOCUMENT'}
                            {attachments?.length > 0 && (
                              <span style={{ color: 'white' }}>{'\xa0' + `(${attachments?.length} out of 6)`}</span>
                            )}
                          </Button>
                        </Box>
                      </Grid>
                      <Grid sx={{ marginX: '10px' }} lg={10}>
                        <Attachment
                          view={editMode === true ? false : true}
                          attachments={attachments}
                          setAttachments={setAttachments}
                          updateAttachmentName={updateAttachmentName}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
            {/* form 4 */}
            {activeStep == 2 && (
              <Box
                id="Box03"
                className={'custom-scrollbar'}
                sx={{
                  width: '100%',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  boxSizing: 'border-box',
                }}
              >
                <AllSettings setHideFloatBtn={setHideFloatBtn} />
              </Box>
            )}
          </Box>
        </Box>
        <DraggableAction
          actionType="CompanySetUp"
          saveText={saveSkipStatus && activeStep === 2 ? 'Back to Dashboard' : editMode === true ? 'Save & Next' : 'Enable Edit'}
          onEnableEdit={async () => {
            if (activeStep === 1) {
              partyTransactionApicall();
            }
            setEditMode(true);
          }}
          hideFloatBtn={hideFloatBtn}
          editMode={editMode}
          onSave={(event) => {
            if (activeStep === 0 && editMode === true) {
              handleSteps(event, 1, false);
            } else if (activeStep === 1 && editMode === true) {
              handleSteps(event, 2, false);
            } else {
              handleSteps(event, 3, false);
            }
          }}
          onKeyPress={(e) => {
            if (e?.key === 'Tab' && e.shiftKey) {
              e.stopPropagation();
            } else if (e.key == 'Tab' && !backdropOpen) {
              e.preventDefault();
              e.stopPropagation();
              if (activeStep === 0) {
                handleSteps(e, 1, false);
              } else if (activeStep === 1) {
                // handleSteps(editCompanyDetails, 2);
                handleSteps(e, 2, false);
              } else {
                e.preventDefault();
                handleSteps(e, 3, false);
              }
            }
          }}
          onSkip={
            activeStep !== 2
              ? () => {
                  setCancelModal(true);
                }
              : null
          }
          onPrevs={activeStep !== 0 ? () => slideLeft() : null}
        />
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={!state.formone.status}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <ConfirmCancel open={cancelModal} setOpen={setCancelModal} />
        {/* {lutViewModalOpen && (
          <LutViewNewModal
            open={lutViewModalOpen}
            setOpen={setLutViewModalOpen}
            currentYear={currentYear}
            setLutRows={setLutRows}
            lutRows={lutRows}
            lutState={state}
            setLutState={setState}
          />
        )} */}
        {openBusinessIndustryTypeModal ? (
          <AddTypeModal
            companyId={comId}
            open={openBusinessIndustryTypeModal}
            setOpen={setOpenBusinessIndustryTypeMdal}
            setState={setState}
            state={state}
            type={businessorIndustryType}
            options={
              businessorIndustryType === 'BusinessType' ? businessTypes : businessorIndustryType === 'IndustryType' ? industryTypes : []
            }
          />
        ) : null}
      </Box>
      <SimpleModal open={ewayNotes} setOpen={setEwayNotes} title={'Steps to Configure & Generate E-Way Bill'} body={ewayBillNotes} />
      <SimpleModal open={eInvNotes} setOpen={setEInvNotes} title={'Steps to Configure & Generate E-invoice'} body={einvNotes} />
    </Box>
  );
}

export default NewCompanySetup;
